<template>
	<div>
		<el-row>
			<el-col>
				<el-form :inline='true' :model="filters">
					<el-form-item label="关键字：" >
						<el-input v-model="filters.headlineOrCode" clearable placeholder="请输入标题或者编号搜索" width="120px"></el-input>
					</el-form-item>
					<el-form-item label="产品形式：">
						<el-select v-model="filters.category" style="width: 160px" placeholder="产品形式" filterable clearable>
							<el-option
									v-for="item in categoryList"
									:key="item.id"
									:label="item.name"
									:value="item.id"
							></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="产品分类：">
						<el-select v-model="filters.productTypeId" style="width: 160px" placeholder="产品分类" filterable clearable>
							<el-option
									v-for="item in productTypeIdList"
									:key="item.id"
									:label="item.name"
									:value="item.id"
							></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="发布状态：">
						<el-select v-model="filters.status"  style="width: 160px" placeholder="请选择是否有标签" filterable clearable>
							<el-option
									v-for="item in statusList"
									:key="item.id"
									:label="item.name"
									:value="item.id"
							></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="发布日期：">
						<el-date-picker
								clearable
								v-model="filters.releaseTime"
								type="date"
								value-format="yyyy-MM-dd"
								format="yyyy-MM-dd"
								placeholder="选择日期">
						</el-date-picker>
					</el-form-item>
					<el-form-item>
						<toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>
					</el-form-item>
				</el-form>
			</el-col>
		</el-row>
		
		<el-radio-group style="margin-bottom: 30px;"  v-model="activeName"  @input="handleClick">
			<el-radio-button label="first">单品</el-radio-button>
			<el-radio-button label="second">合集</el-radio-button>
		</el-radio-group>
		
		<!-- 单品列表 -->
		<div class="first" v-if="activeName === 'first'">
			<el-table
				:data="tableData"
				border
				style="width: 100%;"
				v-loading="listLoading"
				@current-change='currentChange'
				:highlight-current-row='true'
		>
			<el-table-column prop="code" label="编号"  width='150' align="center" ></el-table-column>
			<el-table-column prop="headline" label="产品标题"  min-width='250' align="center" >
				<template #default='scope'>
					<div style="white-space: normal; text-align: center; line-height: normal;">
						<el-button type="text" style="white-space: normal;line-height:18px" @click="clickRelatedHeadline(scope.row)">{{scope.row.headline}}</el-button>
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="category" label="产品形式"  width='90' align="center" >
				<template #default='scope'>
					<el-tag v-if='scope.row.category === 1' type='success'>{{'视频'}}</el-tag>
					<el-tag v-else-if='scope.row.category === 2' type='success'>{{'word'}}</el-tag>
					<el-tag v-else-if="scope.row.category === 3" type='warning'>{{'ppt'}}</el-tag>
					<el-tag v-else type='warning'>{{'pdf'}}</el-tag>
				</template>
			</el-table-column>
			<el-table-column prop="productTypeName" label="产品分类"  width='90' align="center" ></el-table-column>
			<el-table-column prop="productFileCount" label="主体文件"  width='90' align="center" >
				<template #default='scope'>
					<el-button type="text" @click="clickRelatedHeadline(scope.row,1)">{{scope.row.productFileCount}}</el-button>
				</template>
			</el-table-column>
			<el-table-column prop="productFileInvestigationCount" label="调查报告"  width='90' align="center" >
				<template #default='scope'>
					<el-button type="text" @click="clickRelatedProductFileInvestigationCount(scope.row)">{{scope.row.productFileInvestigationCount}}</el-button>
				</template>
			</el-table-column>
			<el-table-column prop="productFileJudgementCount" label="判决书"  width='90' align="center" >
				<template #default='scope'>
					<el-button type="text" @click="clickRelatedProductFileJudgementCount(scope.row)">{{scope.row.productFileJudgementCount}}</el-button>
				</template>
			</el-table-column>
			<el-table-column prop="productFileOtherCount" label="其它文档"  width='90' align="center" >
				<template #default='scope'>
					<el-button type="text" @click="clickRelatedProductFileOtherCount(scope.row)">{{scope.row.productFileOtherCount}}</el-button>
				</template>
			</el-table-column>
			<el-table-column prop="productFileTotalPrice" label="总价"  width='90' align="center" >
				<template #default='scope'>
					<el-button type="text" @click="clickRelatedProductFileTotalPrice(scope.row)">{{scope.row.productFileTotalPrice}}</el-button>
				</template>
			</el-table-column>
			<el-table-column prop="isPerfect" label="主体是否完善"  width='120' align="center" >
				<template #default='scope'>
					<el-tag v-if='scope.row.isPerfect' type='success'>是</el-tag>
					<el-tag v-else type='warning'>否</el-tag>
				</template>
			</el-table-column>
			<el-table-column prop="isHot" label="是否热门"  width='90' align="center" >
				<template #default='scope'>
					<el-tag v-if='scope.row.isHot' type='success'>是</el-tag>
					<el-tag v-else type='warning'>否</el-tag>
				</template>
			</el-table-column>
			<el-table-column prop="isFree" label="是否免费"  width='90' align="center" >
				<template #default='scope'>
					<el-tag v-if='scope.row.isFree' type='success'>是</el-tag>
					<el-tag v-else type='warning'>否</el-tag>
				</template>
			</el-table-column>
			<el-table-column prop="isTop" label="是否置顶"  width='90' align="center" >
				<template #default='scope'>
					<el-tag v-if='scope.row.isTop' type='success'>是</el-tag>
					<el-tag v-else type='warning'>否</el-tag>
				</template>
			</el-table-column>
			<el-table-column prop="topTime" label="置顶时间"  width='180' align="center" ></el-table-column>
			<el-table-column prop="status" label="发布状态"  width='90' align="center" >
				<template #default='scope'>
					<el-tag v-if='scope.row.status===0' type='danger'>未发布</el-tag>
					<el-tag v-else-if='scope.row.status===1' type='success'>已发布</el-tag>
					<el-tag v-else-if='scope.row.status===4' >维护中</el-tag>
					<el-tag v-else-if='scope.row.status===3' type='warning'>已下架</el-tag>
				</template>
			</el-table-column>
			<el-table-column prop="issuerName" label="发布人"  width='90' align="center" ></el-table-column>
			<el-table-column prop="releaseTime" label="发布时间"  width='180' align="center" ></el-table-column>
			<el-table-column prop="questionCount" label="试题数量"  width='90' align="center">
				<template #default="scope">
					<span style="color:red;cursor:pointer;" @click="handleQuestionCount(scope.row)">
						{{scope.row.questionCount}}
					</span>
				</template>
			</el-table-column>
		</el-table>
		<el-col :span="24" class="pageBar" style="margin:20px 0">
			<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page="pages.pageIndex"
					:page-sizes="pages.pageArr"
					:page-size="pages.pageSize"
					layout="total, sizes, prev, pager, next, jumper"
					:total="pages.dataCount">
			</el-pagination>
		</el-col>
		</div>
		
		<!--合集列表-->
		<div class="second" v-if="activeName === 'second'">
		<el-table
				:data="tableData3"
				border
				style="width: 100%;"
				v-loading="listLoading"
				@current-change='currentChange2'
				:highlight-current-row='true'
		>			
			<el-table-column prop="compilationsCode" label="编号"  width='110' align="center" ></el-table-column>
			<el-table-column prop="compilationsHeadline" label="产品标题"  width='150' align="center" >
				<template #default='scope'>
					<el-button type="text" @click="clickCollectionName(scope.row)">{{scope.row.compilationsHeadline}}</el-button>
				</template>
			</el-table-column>
			<el-table-column prop="category" label="产品形式"  width='' align="center" >
				<template #default='scope'>
					<el-tag v-if='scope.row.category === 1' type='success'>{{'视频'}}</el-tag>
					<el-tag v-else-if='scope.row.category === 2' type='success'>{{'word'}}</el-tag>
					<el-tag v-else type='warning'>{{'ppt'}}</el-tag>
				</template>
			</el-table-column>
			<el-table-column prop="productTypeName" label="产品分类"  width='' align="center" ></el-table-column>
			<el-table-column prop="productsCount" label="产品数量"  width='' align="center" ></el-table-column>
			<el-table-column prop="compilationsPrice" label="总价"  width='' align="center" >
				<template #default='scope'>
					<el-button type="text" @click="clickRelatedProductFileTotalPrice(scope.row)">{{scope.row.compilationsPrice}}</el-button>
				</template>
			</el-table-column>
			<el-table-column prop="isHot" label="是否热门"  width='' align="center" >
				<template #default='scope'>
					<el-tag v-if='scope.row.isHot' type='success'>是</el-tag>
					<el-tag v-else type='warning'>否</el-tag>
				</template>
			</el-table-column>
			<el-table-column prop="isFree" label="是否免费"  width='' align="center" >
				<template #default='scope'>
					<el-tag v-if='scope.row.isFree' type='success'>是</el-tag>
					<el-tag v-else type='warning'>否</el-tag>
				</template>
			</el-table-column>
			<el-table-column prop="isTop" label="是否置顶"  width='' align="center" >
				<template #default='scope'>
					<el-tag v-if='scope.row.isTop' type='success'>是</el-tag>
					<el-tag v-else type='warning'>否</el-tag>
				</template>
			</el-table-column>
			<el-table-column prop="topTime" label="置顶时间"  width='200' align="center" ></el-table-column>
			<el-table-column prop="status" label="发布状态"  width='' align="center" >
				<template #default='scope'>
					<el-tag v-if='scope.row.status===0' type='danger'>未发布</el-tag>
					<el-tag v-else-if='scope.row.status===1' type='success'>已发布</el-tag>
					<el-tag v-else-if='scope.row.status===4' >维护中</el-tag>
					<el-tag v-else-if='scope.row.status===3' type='warning'>已下架</el-tag>
				</template>
			</el-table-column>
			<el-table-column prop="issuerName" label="发布人"  width='' align="center" ></el-table-column>
			<el-table-column prop="releaseTime" label="发布时间"  width='' align="center" ></el-table-column>
		</el-table>
		<!--底部工具条-->
		<el-col :span="24" class="pageBar" style="margin:20px 0">
			<el-pagination
					@size-change="handleSizeChange1"
					@current-change="handleCurrentChange1"
					:current-page="pages1.pageIndex"
					:page-sizes="pages1.pageArr"
					:page-size="pages1.pageSize"
					layout="total, sizes, prev, pager, next, jumper"
					:total="pages1.dataCount">
			</el-pagination>
		</el-col>
		</div>
		
<!--添加编辑单品弹窗-->
		<el-dialog
				:title= "editFalse?'编辑单品':'创建单品'"
				:visible.sync="dialogs.addType.dialog"
				width="55%"
				style="min-width: 300px"
				:close-on-click-modal='false'
		>
			<el-form :model="addForm"  :rules="addFormRules"  ref="Form" label-width="160px">
				<el-form-item label="标题"  prop="headline">
					<el-input v-model="addForm.headline"  placeholder="请输入标题" style="width: 50%"></el-input>
				</el-form-item>
				<el-form-item label="编号"  prop="code">
					<el-input v-model="addForm.code" placeholder="请输入标题" style="width: 50%"></el-input>
				</el-form-item>
				<div class="all">
					<el-form-item label="产品分类："  prop="productTypeId">
						<el-select v-model="addForm.productTypeId" @change="selectRowChangeProduct" style="width: 150px" placeholder="请选择视频类型" filterable clearable>
							<el-option
									v-for="item in productTypeIdList"
									:key="item.id"
									:label="item.name"
									:value="item.id"
							></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label=""  prop="productTypeSecondId" class="item">
						<el-select v-model="addForm.productTypeSecondId" style="width: 150px;"  clearable  filterable placeholder="请选择二级分类">
									<el-option
											v-for="item in productTypeIdChildList"
											:key="item.id"
											:label="item.name"
											:value="item.id">
									</el-option>
						</el-select>
					</el-form-item>
				</div>
				<el-form-item label="主题是否完善："  prop="isPerfect">
					<el-radio-group v-model="addForm.isPerfect">
						<el-radio :label="true">是</el-radio>
						<el-radio :label="false">否</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="严重程度："  prop="disasterGrade">
					<el-radio v-model="addForm.disasterGrade" :label="0">一般</el-radio>
					<el-radio v-model="addForm.disasterGrade" :label="1">较大</el-radio>
					<el-radio v-model="addForm.disasterGrade" :label="2">重大</el-radio>
					<el-radio v-model="addForm.disasterGrade" :label="3">特大</el-radio>
				</el-form-item>
				<div class="all">
					<el-form-item label="所在区域："  prop="provinceId">
						<el-select filterable clearable placeholder="请选择省" v-model="addForm.provinceId" @change="selectRowChangeSheng">
							<el-option
									v-for="item in shengArr"
									:key="item.id"
									:label="item.name"
									:value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item   prop="cityId" class="item">
						<el-select v-model="addForm.cityId" clearable  filterable placeholder="请选择市">
							<el-option
									v-for="item in cityArr"
									:key="item.id"
									:label="item.name"
									:value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
				</div>
				<el-form-item label="火灾日期："  prop="disasterTime">
					<el-date-picker
							v-model="addForm.disasterTime"
							type="date"
							value-format="yyyy-MM-dd"
							format="yyyy-MM-dd"
							placeholder="选择日期">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="伤亡人数："  prop="casualtiesCount">
					<el-input v-model="addForm.casualtiesCount" placeholder="请输入" style="width: 50%"></el-input>
				</el-form-item>
				<el-form-item label="产品形式："  prop="category">
					<el-radio-group v-model="addForm.category" @change="changeCategory2">
						<el-radio :label="1">视频（mp4）</el-radio>
						<el-radio :label="2">Word（doc/docx）</el-radio>
						<el-radio :label="3">PPT（ppt/pptx）</el-radio>
						<el-radio :label="4">PDF</el-radio>
					</el-radio-group>
				</el-form-item>
				<div style="margin-bottom: 10px;margin-left: 50px;font-weight: bold;font-size: 16px">
					上传主体文件
				</div>
				<el-form-item label="原始作者："  prop="authorId">
					<el-select v-model="addForm.authorId" style="width: 50%" placeholder="请选择" filterable clearable>
						<el-option
								v-for="item in authorIdList"
								:key="item.id"
								:label="item.name"
								:value="item.id"
						></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="策划："  prop="mastermindId">
					<el-select v-model="addForm.mastermindId" style="width: 50%" placeholder="请选择" filterable clearable>
						<el-option
								v-for="item in authorIdList"
								:key="item.id"
								:label="item.name"
								:value="item.id"
						></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="后期："  prop="anaphaseId">
					<el-select v-model="addForm.anaphaseId" multiple style="width: 50%"  placeholder="请选择" filterable clearable>
						<el-option
								v-for="item in authorIdList"
								:key="item.id"
								:label="item.name"
								:value="item.id"
						></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="封面图片："  prop="firstImageUrl">
					<template >
						<div style="display: flex;justify-content: left;align-items: flex-end">
							<div class="avatar-uploader">
								<el-upload
										:action="actionUrl"
										:headers="headers"
										:before-upload="beforeUpload"
										:on-success="handle_success"
										:show-file-list="false"
								
								>
									<img v-if="addForm.firstImageUrl !== ''"  :src="addForm.firstImageUrl"  class="avatar" />
									<i v-else  class="el-icon-plus avatar-uploader-icon"></i>
								
								</el-upload>
							</div>
							<div style="margin: 0px 20px;">{{'推荐比例：16:9'}}</div>
							<div class="avatar-uploader3">
							<el-upload
									:action="actionUrl"
									:headers="headers"
									:before-upload="beforeUpload"
									:on-success="handle_success2"
									:show-file-list="false"
							
							>
								<img v-if="addForm.verticalImageUrl !== ''"  :src="addForm.verticalImageUrl"  class="avatar3" />
								
								<i v-else  class="el-icon-plus avatar-uploader-icon3"></i>
							
							</el-upload>
							</div>
							<div style="margin: 0px 20px;">{{'推荐比例：3:4'}}</div>
						</div>
					</template>
				</el-form-item>
				<el-form-item   prop="productFileId" label="上传视频文件：" v-if="selsetCategory===1">
					<template>
						<div class="hello">
							<div>
								<input type="file" :key="inputKey" class="upload" @change="doUpload" ref="inputer" />
							</div>
							
							<div>
								<el-table :data="tableData1" border style="width: 100%">
									<el-table-column prop="fileName" label="文件名" width="">
									</el-table-column>
									<el-table-column prop="size" label="文件大小" width="120">
										<template slot-scope="scope">{{ transformSize(scope.row.fileSize)}}</template>
									</el-table-column>
									<el-table-column prop="progress" label="进度" width="180">
										<template slot-scope="scope">
											<el-progress :text-inside="true" :stroke-width="26" :percentage="scope.row.progress"></el-progress>
										</template>
									
									</el-table-column>
									<el-table-column prop="progress" label="操作" width="160">
										<template slot-scope="scope" >
											<el-button type="text" size="small"  @click="start(scope.row.id)">开始</el-button>
											<el-button type="text" size="small" @click="stop(scope.row.id)">暂停</el-button>
											<el-button type="text" size="small" @click="remove(scope.row.id)">删除</el-button>
										</template>
									</el-table-column>
								</el-table>
							</div>
						</div>
					</template>
				</el-form-item>
				<el-form-item  prop="productName"  label="上传文档：" v-else>
					<el-upload
							:action="actionUrlFile"
							:headers="headers"
							:data="uploadData"
							:before-upload="beforeUpload_file"
							:on-success="handle_success_file2"
							:show-file-list="true"
							:limit="5"
							:file-list="fileList"
					>
						<el-button size="small" type="primary">点击上传</el-button>
					</el-upload>
				</el-form-item>
				<el-form-item  prop="productIntroduce"  label="简介：">
					<el-input v-model="addForm.productIntroduce" type="textarea" rows="3"  style="width: 50%"></el-input>
				</el-form-item>
				<el-form-item  prop="productTagId"  label="标签：">
					<el-select v-model="addForm.productTagId" multiple style="width: 50%" placeholder="请选择" filterable clearable>
						<el-option
								v-for="item in tagTypeIdList"
								:key="item.id"
								:label="item.name"
								:value="item.id"
						></el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
                <el-button @click="dialogs.addType.dialog = false;">取 消</el-button>
                <el-button type="primary" @click="addConfirm" :loading="listLoading">确认</el-button>
            </span>
		</el-dialog>
		
<!--创建和编辑合集-->
		<el-dialog
				:title= "editFalse?'编辑合集':'创建合集'"
				:visible.sync="dialogs.addCollection.dialog"
				width="50%"
				:close-on-click-modal='false'
		>

			<el-form :model="addForm"  ref="addRealation" :rules="addFormRules2" label-width="160px">
				<el-form-item label="标题："  prop="compilationsHeadline">
					<el-input v-model="addForm.compilationsHeadline"   style="width: 50%"></el-input>
				</el-form-item>
				<el-form-item label="产品编号："  prop="compilationsCode">
					<el-input v-model="addForm.compilationsCode"   style="width: 50%"></el-input>
				</el-form-item>
				<el-form-item label="产品形式："  prop="category">
					<el-radio v-model="addForm.category" :label="1">视频（mp4）</el-radio>
					<el-radio v-model="addForm.category" :label="2">Word（doc/docx）</el-radio>
					<el-radio v-model="addForm.category" :label="3">PPT（ppt/pptx）</el-radio>
					<el-radio v-model="addForm.category" :label="4">游戏</el-radio>
				</el-form-item>
				<div class="all">
					<el-form-item label="产品分类："  prop="productTypeId">
						<el-select v-model="addForm.productTypeId" @change="selectRowChangeProduct"  placeholder="请选择视频类型" filterable clearable>
							<el-option
									v-for="item in productTypeIdList"
									:key="item.id"
									:label="item.name"
									:value="item.id"
							></el-option>
						</el-select>
						
					</el-form-item>
					<el-form-item label=""  prop="productTypeSecondId" class="item">
						<el-select v-model="addForm.productTypeSecondId" clearable  filterable placeholder="请选择二级分类">
							<el-option
									v-for="item in productTypeIdChildList"
									:key="item.id"
									:label="item.name"
									:value="item.id">
							</el-option>
						</el-select>
						
					</el-form-item>
				</div>
				<el-form-item label="合集封面：" prop="compilationsCoverImage">
					<template >
						<div style="display: flex;justify-content: left;align-items: flex-end">
							<div class="avatar-uploader">
								<el-upload
										:action="actionUrl"
										:headers="headers"
										:before-upload="beforeUpload"
										:on-success="handle_success"
										:show-file-list="false"										
								
								>
									<img v-if="addForm.compilationsCoverImage !== ''"  :src="addForm.compilationsCoverImage"  class="avatar" />									
									<i v-else  class="el-icon-plus avatar-uploader-icon"></i>
								</el-upload>
							</div>
							<div style="margin: 0px 20px;">{{'推荐比例：16:9'}}</div>
						</div>
					</template>
				</el-form-item>
				<el-form-item label="关联单品："  prop="relatedTableData">
					<el-button type="primary" @click="relatedItems">添加</el-button>
				</el-form-item>
			</el-form>
			<el-table
				:data="relatedTableData"
				  ref="tableRef"
				border
				style="width: 100%;"
				v-loading="relatedListLoading"
				@current-change='currentChange'
				:highlight-current-row='true' 
				 row-key="id" 
		>
				<el-table-column type='index' label="序号" width='80' align="center" :index='indexMethod'></el-table-column>
				<el-table-column prop="headline" label="产品标题"  width='' align="center" ></el-table-column>
				<el-table-column prop="category" label="产品形式"  width='' align="center" >
					<template #default='scope'>
						<el-tag v-if='scope.row.category === 1' type='success'>{{'视频'}}</el-tag>
						<el-tag v-else-if='scope.row.category === 2' type='success'>{{'word'}}</el-tag>
						<el-tag v-else type='warning'>{{'ppt'}}</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="productTypeName" label="产品分类"  width='' align="center" ></el-table-column>
					<el-table-column prop="productFileCount" label="主体文件"  width='' align="center" >
						<template #default='scope'>
							<el-button type="text" @click="clickRelatedHeadline(scope.row)">{{scope.row.productFileCount}}</el-button>
						</template>
					</el-table-column>
					<el-table-column prop="productFileInvestigationCount" label="调查报告"  width='' align="center" >
						<template #default='scope'>
							<el-button type="text" @click="clickRelatedProductFileInvestigationCount(scope.row)">{{scope.row.productFileInvestigationCount}}</el-button>
						</template>
					</el-table-column>
					<el-table-column prop="productFileJudgementCount" label="判决书"  width='' align="center" >
						<template #default='scope'>
							<el-button type="text" @click="clickRelatedProductFileJudgementCount(scope.row)">{{scope.row.productFileJudgementCount}}</el-button>
						</template>
					</el-table-column>
					<el-table-column prop="productFileOtherCount" label="其它文档"  width='' align="center" >
						<template #default='scope'>
							<el-button type="text" @click="clickRelatedProductFileOtherCount(scope.row)">{{scope.row.productFileOtherCount}}</el-button>
						</template>
					</el-table-column>
					<el-table-column label="操作">
						<template #default='scope'>
							<el-button type="danger" @click="deleteRelation(scope.row)">删除</el-button>
						</template>
					</el-table-column>
		
			</el-table>
			<span  slot="footer" class="dialog-footer">
          <el-button @click="dialogs.addCollection.dialog = false">取 消</el-button>
          <el-button type="primary" @click="addRelationConfirm" :loading="listLoading">确认</el-button>
      </span>
		</el-dialog>
		
<!--关联单品弹窗-->
		<el-dialog
				title= "关联单品"
				:visible.sync="relatedDialogList"
				width="80%"
				:close-on-click-modal='false'
		>
			<el-table
					:data="relatedSelectionTableData"
					border
					style="width: 100%;"
					v-loading="relatedSelectionListLoading"
					@selection-change="handleSelectionChange"
					:highlight-current-row='true'
			>
				<el-table-column  type="selection"></el-table-column>
				<el-table-column prop="code" label="编号"  width='' align="center" ></el-table-column>
				<el-table-column prop="headline" label="产品标题"  width='' align="center" ></el-table-column>
				<el-table-column prop="category" label="产品形式"  width='' align="center" >
					<template #default='scope'>
						<el-tag v-if='scope.row.category === 1' type='success'>{{'视频'}}</el-tag>
						<el-tag v-else-if='scope.row.category === 2' type='success'>{{'word'}}</el-tag>
						<el-tag v-else type='warning'>{{'ppt'}}</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="productTypeName" label="产品分类"  width='' align="center" ></el-table-column>
				<el-table-column prop="productFileCount" label="主体文件"  width='' align="center" >
					<template #default='scope'>
						<el-button type="text" @click="clickRelatedHeadline(scope.row)">{{scope.row.productFileCount}}</el-button>
					</template>
				</el-table-column>
				<el-table-column prop="productFileInvestigationCount" label="调查报告"  width='' align="center" >
					<template #default='scope'>
						<el-button type="text" @click="clickRelatedProductFileInvestigationCount(scope.row)">{{scope.row.productFileInvestigationCount}}</el-button>
					</template>
				</el-table-column>
				<el-table-column prop="productFileJudgementCount" label="判决书"  width='' align="center" >
					<template #default='scope'>
						<el-button type="text" @click="clickRelatedProductFileJudgementCount(scope.row)">{{scope.row.productFileJudgementCount}}</el-button>
					</template>
				</el-table-column>
				<el-table-column prop="productFileOtherCount" label="其它文档"  width='' align="center" >
					<template #default='scope'>
						<el-button type="text" @click="clickRelatedProductFileOtherCount(scope.row)">{{scope.row.productFileOtherCount}}</el-button>
					</template>
				</el-table-column>
			</el-table>
				<!--底部工具条-->
			<el-col :span="24" class="pageBar" style="margin:20px 0">
				<el-pagination
						@size-change="handleSizeChange2"
						@current-change="handleCurrentChange2"
						:current-page="pages2.pageIndex"
						:page-sizes="pages2.pageArr"
						:page-size="pages2.pageSize"
						layout="total, sizes, prev, pager, next, jumper"
						:total="pages2.dataCount">
				</el-pagination>
			</el-col>
			<span  slot="footer" class="dialog-footer">
          		<el-button @click="confirmList">确认</el-button>
      		</span>
		</el-dialog>
		
	<!--点击合集中产品标题弹窗-->
		<el-dialog
				title= "合集"
				:visible.sync="collectionDialog.compilationsHeadline"
				width="50%"
				:close-on-click-modal='false'
		>
			<el-table
					:data="collectionNameDialogData"
					border
					style="width: 100%;"
					v-loading="relatedListLoading"
					@current-change='currentChange3'
					:highlight-current-row='true'
			>
				<el-table-column type='index' label="序号" width='80' align="center" :index='indexMethod'></el-table-column>
				<el-table-column prop="code" label="编号"  width='130' align="center" ></el-table-column>
				<el-table-column prop="headline" label="产品标题"  width='260' align="center" >
					<template #default='scope'>
						<el-button type="text" @click="clickRelatedHeadline(scope.row)">{{scope.row.headline}}</el-button>
					</template>
				</el-table-column>
				<el-table-column prop="category" label="产品形式"  width='100' align="center" >
					<template #default='scope'>
						<el-tag v-if='scope.row.category === 1' type='success'>{{'视频'}}</el-tag>
						<el-tag v-else-if='scope.row.category === 2' type='success'>{{'word'}}</el-tag>
						<el-tag v-else type='warning'>{{'ppt'}}</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="productTypeName" label="产品分类"  width='100' align="center" ></el-table-column>
				<el-table-column prop="productFileCount" label="主体文件"  width='100' align="center" >
					<template #default='scope'>
						<el-button type="text" @click="clickRelatedHeadline(scope.row,1)">{{scope.row.productFileCount}}</el-button>
					</template>
				</el-table-column>
				<el-table-column prop="productFileInvestigationCount" label="调查报告"  width='100' align="center" >
					<template #default='scope'>
						<el-button type="text" @click="clickRelatedProductFileInvestigationCount(scope.row)">{{scope.row.productFileInvestigationCount}}</el-button>
					</template>
				</el-table-column>
				<el-table-column prop="productFileJudgementCount" label="判决书"  width='100' align="center" >
					<template #default='scope'>
						<el-button type="text" @click="clickRelatedProductFileJudgementCount(scope.row)">{{scope.row.productFileJudgementCount}}</el-button>
					</template>
				</el-table-column>
				<el-table-column prop="productFileOtherCount" label="其它文档"  width='100' align="center" >
					<template #default='scope'>
						<el-button type="text" @click="clickRelatedProductFileOtherCount(scope.row)">{{scope.row.productFileOtherCount}}</el-button>
					</template>
				</el-table-column>
				<el-table-column prop="productFileRelatedCount" label="相关资料"  width='100' align="center" >
					<template #default='scope'>
						<el-button type="text" @click="clickRelatedProductFileRelatedCount(scope.row)">{{scope.row.productFileRelatedCount}}</el-button>
					</template>
				</el-table-column>
			</el-table>
		</el-dialog>
		<!--	点击单品中产品标题弹窗	-->
		<el-dialog
				title="单品"
				:visible.sync="relatedDialog.headline"
				width="50%"
				:close-on-click-modal='false'
		>
		<el-tabs v-model="activetagIndex" type="card" @tab-click="handleClick2">
			<el-tab-pane label="基本信息" name="1">
				<el-form :model="addForm"   label-width="140px">
						<el-form-item label="产品标题:"  prop="headline" style="margin-bottom:10px;">
							<el-input disabled  v-model="addForm.headline" placeholder="请输入标题" style="width: 50%"></el-input>
						</el-form-item>
						<el-form-item label="产品编号:"  prop="code" style="margin-bottom:10px;">
							<el-input disabled v-model="addForm.code" placeholder="请输入标题" style="width: 50%"></el-input>
						</el-form-item>
						<el-form-item label="产品分类："  prop="productTypeId" style="margin-bottom:10px;">
							<el-select disabled v-model="addForm.productTypeId" style="width: 50%" placeholder="请选择视频类型" filterable clearable>
								<el-option
										v-for="item in productTypeIdList"
										:key="item.id"
										:label="item.name"
										:value="item.id"
								></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="严重程度："  prop="disasterGrade" style="margin-bottom:10px;">
							<el-radio disabled v-model="addForm.disasterGrade" :label="1">较大</el-radio>
							<el-radio disabled v-model="addForm.disasterGrade" :label="2">重大</el-radio>
							<el-radio disabled v-model="addForm.disasterGrade" :label="3">特大</el-radio>
							<el-radio disabled v-model="addForm.disasterGrade" :label="0">一般</el-radio>
						</el-form-item>
						<el-form-item label="所在区域："  prop="provinceId" style="margin-bottom:10px;">
							<el-select  placeholder="请选择省" filterable disabled clearable v-model="addForm.provinceId"  @change="selectRowChangeSheng"    >
								<el-option
										v-for="item in shengArr"
										:key="item.id"
										:label="item.name"
										:value="item.id">
								</el-option>
							</el-select>
							<el-select disabled v-model="addForm.cityId" clearable  filterable placeholder="请选择市">
								<el-option
										v-for="item in cityArr"
										:key="item.id"
										:label="item.name"
										:value="item.id">
								</el-option>
							</el-select>
						
						</el-form-item>
						<el-form-item label="火灾日期："  prop="disasterTime" style="margin-bottom:10px;">
							<el-date-picker
									disabled
									v-model="addForm.disasterTime"
									type="date"
									value-format="yyyy-MM-dd"
									format="yyyy-MM-dd"
									placeholder="选择日期">
							</el-date-picker>
						</el-form-item>
						
						<el-form-item label="伤亡人数："  prop="casualtiesCount" style="margin-bottom:10px;">
							<el-input disabled v-model="addForm.casualtiesCount" placeholder="请输入" style="width: 50%"></el-input>
						</el-form-item>
						<el-form-item label="产品形式："  prop="category" style="margin-bottom:10px;">
							<el-radio disabled v-model="addForm.category" :label="1">视频（mp4）</el-radio>
							<el-radio disabled v-model="addForm.category" :label="2">Word（doc/docx）</el-radio>
							<el-radio disabled v-model="addForm.category" :label="3">PPT（ppt/pptx）</el-radio>
							<el-radio disabled v-model="addForm.category" :label="4">游戏</el-radio>
						</el-form-item>
						<div style="margin-bottom: 10px;margin-left: 50px;font-weight: bold;font-size: 16px">
							上传主体文件
						</div>
						<el-form-item label="原始作者："  prop="authorId" style="margin-bottom:10px;">
							<el-select disabled v-model="addForm.authorId" style="width: 50%" placeholder="请选择" filterable clearable>
								<el-option
										v-for="item in authorIdList"
										:key="item.id"
										:label="item.name"
										:value="item.id"
								></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="策划："  prop="mastermindId" style="margin-bottom:10px;">
							<el-select disabled v-model="addForm.mastermindId" style="width: 50%" placeholder="请选择" filterable clearable>
								<el-option
										v-for="item in authorIdList"
										:key="item.id"
										:label="item.name"
										:value="item.id"
								></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="后期："  prop="anaphaseId" style="margin-bottom:10px;">
							<el-select disabled v-model="addForm.anaphaseId"  multiple style="width: 50%" placeholder="请选择" filterable clearable>
								<el-option
										v-for="item in authorIdList"
										:key="item.id"
										:label="item.name"
										:value="item.id"
								></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="封面图片："  prop="firstImageUrl" style="margin-bottom:10px;">
							<template>
								<div style="display: flex;justify-content: flex-start;">
									<div class="avatar-uploader">
										<img  :src="addForm.firstImageUrl" class="avatar" />
									</div>
									<div  class="avatar-uploader3" style="margin-left: 20px">
										<img  :src="addForm.verticalImageUrl" class="avatar3" />
									</div>
								</div>
							</template>
						</el-form-item>
						<el-form-item  prop="productIntroduce"  label="简介：" style="margin-bottom:10px;">
							<el-input disabled v-model="addForm.productIntroduce" type="textarea" rows="3"  style="width: 50%"></el-input>
						</el-form-item>
						<el-form-item  prop="productTagId"  label="标签：" style="margin-bottom:10px;">
							<el-select disabled v-model="addForm.productTagId" multiple style="width: 50%" placeholder="请选择" filterable clearable>
								<el-option
										v-for="item in tagTypeIdList"
										:key="item.id"
										:label="item.name"
										:value="item.id"
								></el-option>
							</el-select>
						</el-form-item>
					</el-form>
			</el-tab-pane>
			<el-tab-pane label="调查报告" name="2">
				<el-form :model="addForm"   label-width="140px">
						<el-form-item label="产品标题："  :rules="{ required: true, message: '标题不能为空', trigger: 'blur'}" prop="compilationsHeadline">
							<el-input disabled v-model="addForm.headline"   style="width: 50%"></el-input>
						</el-form-item>
						<div v-if="!hideProduction">
							<!-- <div style="margin: 20px">上传判决书/调查报告/其它文档</div> -->
							<el-form-item label="原始作者：" required prop="authorId">
								<el-select v-model="addForm.authorId" style="width: 50%" @change="changeAuthor"  placeholder="请选择" filterable clearable >
									<el-option
											v-for="item in authorIdList"
											:key="item.id"
											:label="item.name"
											:value="item.id"
									></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="产品形式：" required prop="category">
								<template #default='scope'>
									<el-radio-group v-model="addForm.category" @change="changeCategory">
										<el-radio :label="1">视频（mp4）</el-radio>
										<el-radio :label="2">Word（doc/docx）</el-radio>
										<el-radio :label="3">PPT（ppt/pptx）</el-radio>
										<el-radio :label="4">PDF</el-radio>
									</el-radio-group>
								</template>
							</el-form-item>
							<el-form-item  required prop="fileId" label="上传文件：" v-if="selsetCategory===1">
								<template>
									<div class="hello">
										<div>
											<input type="file" class="upload" @change="doUpload" ref="inputer" multiple disabled />
										</div>
										
										<div style="border-bottom:1px solid #EBEEF5">
											<el-table :data="tableData1" border style="width: 100%">
												<el-table-column prop="fileName" label="文件名" width="">
												</el-table-column>
												<el-table-column prop="size" label="文件大小" width="120">
													<template slot-scope="scope">{{ transformSize(scope.row.fileSize)}}</template>
												</el-table-column>
												<el-table-column prop="progress" label="进度" width="180">
													<template slot-scope="scope">
														<el-progress :text-inside="true" :stroke-width="26" :percentage="scope.row.progress"></el-progress>
													</template>											
												</el-table-column>
												<el-table-column prop="progress" label="操作" width="160">
													<template slot-scope="scope" >
														<el-button disabled type="text" size="small" @click="start(scope.row.id)">开始</el-button>
														<el-button disabled type="text" size="small" @click="stop(scope.row.id)">暂停</el-button>
														<el-button disabled type="text" size="small" @click="remove(scope.row.id)">删除</el-button>
													</template>
												</el-table-column>
											</el-table>
										</div>
									</div>
								</template>
							</el-form-item>
							<el-form-item  prop="productName" required label="上传文档：" v-else>
								<el-upload
										:action="actionUrlFile"
										:headers="headers"
										:data="uploadDataFile"
										:before-upload="beforeUpload_file"
										:on-success="handle_success_file"
										:show-file-list="true"
										:limit="5"
										:file-list="fileList"
								>
									<el-button disabled size="small" type="primary" >点击上传</el-button>
								</el-upload>
							</el-form-item>
						</div>
						<div v-else>
						  <el-empty description="暂无文件"></el-empty>
						</div>
					</el-form>
			</el-tab-pane>
			<el-tab-pane label="判决书" name="3" >
				<el-form :model="addForm"  label-width="140px">
						<el-form-item label="产品标题："  :rules="{ required: true, message: '标题不能为空', trigger: 'blur'}" prop="compilationsHeadline">
							<el-input disabled v-model="addForm.headline"   style="width: 50%"></el-input>
						</el-form-item>
						<div v-if="!hideProduction">
							<!-- <div style="margin: 20px">上传判决书/调查报告/其它文档</div> -->
							<el-form-item label="原始作者：" required prop="authorId">
								<el-select v-model="addForm.authorId" style="width: 50%" @change="changeAuthor" placeholder="请选择" filterable clearable>
									<el-option
											v-for="item in authorIdList"
											:key="item.id"
											:label="item.name"
											:value="item.id"
									></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="产品形式：" required prop="category">
								<template #default='scope'>
									<el-radio-group v-model="addForm.category" @change="changeCategory" >
										<el-radio :label="1">视频（mp4）</el-radio>
										<el-radio :label="2">Word（doc/docx）</el-radio>
										<el-radio :label="3">PPT（ppt/pptx）</el-radio>
										<el-radio :label="4">PDF</el-radio>
									</el-radio-group>
								</template>
							</el-form-item>
							<el-form-item  required prop="fileId" label="上传文件：" v-if="selsetCategory===1">
								<template>
									<div class="hello">
										<div>
											<input type="file"  class="upload" @change="doUpload" ref="inputer" multiple disabled />
										</div>
										
										<div style="border-bottom:1px solid #EBEEF5">
											<el-table :data="tableData1" border style="width: 100%">
												<el-table-column prop="fileName" label="文件名" width="">
												</el-table-column>
												<el-table-column prop="size" label="文件大小" width="120">
													<template slot-scope="scope">{{ transformSize(scope.row.fileSize)}}</template>
												</el-table-column>
												<el-table-column prop="progress" label="进度" width="180">
													<template slot-scope="scope">
														<el-progress :text-inside="true" :stroke-width="26" :percentage="scope.row.progress"></el-progress>
													</template>
												
												</el-table-column>
												<el-table-column prop="progress" label="操作" width="160">
													<template slot-scope="scope" >
														<el-button disabled type="text" size="small" @click="start(scope.row.id)">开始</el-button>
														<el-button disabled type="text" size="small" @click="stop(scope.row.id)">暂停</el-button>
														<el-button disabled type="text" size="small" @click="remove(scope.row.id)">删除</el-button>
													</template>
												</el-table-column>
											</el-table>
										</div>
									</div>
								</template>
							</el-form-item>
							<el-form-item   prop="productName" required label="上传文档：" v-else>
								<el-upload
										:action="actionUrlFile"
										:headers="headers"
										:data="uploadDataFile"
										:before-upload="beforeUpload_file"
										:on-success="handle_success_file"
										:show-file-list="true"
										:limit="5"
										:file-list="fileList"
								>
									<el-button disabled size="small" type="primary">点击上传</el-button>
								</el-upload>
							</el-form-item>
						</div>
						<div v-else>
						 	<el-empty description="暂无文件"></el-empty>
						</div>
					</el-form>
			</el-tab-pane>
			<el-tab-pane label="其他文档" name="4">
				<el-form :model="addForm"   label-width="140px">
						<el-form-item label="产品标题："  :rules="{ required: true, message: '标题不能为空', trigger: 'blur'}" prop="compilationsHeadline">
							<el-input disabled v-model="addForm.headline"   style="width: 50%"></el-input>
						</el-form-item>
						<div v-if="!hideProduction">
							<el-form-item label="原始作者：" required prop="authorId">
								<el-select v-model="addForm.authorId" style="width: 50%" @change="changeAuthor" placeholder="请选择" filterable clearable>
									<el-option
											v-for="item in authorIdList"
											:key="item.id"
											:label="item.name"
											:value="item.id"
									></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="产品形式：" required prop="category">
								<template #default='scope'>
									<el-radio-group v-model="addForm.category" @change="changeCategory">
										<el-radio :label="1">视频（mp4）</el-radio>
										<el-radio :label="2">Word（doc/docx）</el-radio>
										<el-radio :label="3">PPT（ppt/pptx）</el-radio>
										<el-radio :label="4">PDF</el-radio>
									</el-radio-group>
								</template>
							</el-form-item>
							<el-form-item  required prop="fileId" label="上传文件：" v-if="selsetCategory===1">
								<template>
									<div class="hello">
										<div>
											<input type="file" class="upload" @change="doUpload" ref="inputer" multiple disabled />
										</div>
										
										<div >
											<el-table :data="tableData1" border style="width: 100%">
												<el-table-column prop="fileName" label="文件名" width="">
												</el-table-column>
												<el-table-column prop="size" label="文件大小" width="120">
													<template slot-scope="scope">{{ transformSize(scope.row.fileSize)}}</template>
												</el-table-column>
												<el-table-column prop="progress" label="进度" width="180">
													<template slot-scope="scope">
														<el-progress :text-inside="true" :stroke-width="26" :percentage="scope.row.progress"></el-progress>
													</template>
												
												</el-table-column>
												<el-table-column prop="progress" label="操作" width="160">
													<template slot-scope="scope" >
														<el-button type="text" size="small" @click="start(scope.row.id)" disabled>开始</el-button>
														<el-button type="text" size="small" @click="stop(scope.row.id)" disabled>暂停</el-button>
														<el-button type="text" size="small" @click="remove(scope.row.id)" disabled>删除</el-button>
													</template>
												</el-table-column>
											</el-table>
										</div>
									</div>
								</template>
							</el-form-item>
							<el-form-item  prop="productName" required label="上传文档：" v-else>
								<el-upload
										:action="actionUrlFile"
										:headers="headers"
										:data="uploadDataFile"
										:before-upload="beforeUpload_file"
										:on-success="handle_success_file"
										:show-file-list="true"
										:limit="5"
										:file-list="fileList"
								>
									<el-button disabled size="small" type="primary">点击上传</el-button>
								</el-upload>
							</el-form-item>
						</div>
						<div v-else>
						 	<el-empty description="暂无文件"></el-empty>
						</div>
					</el-form>
			</el-tab-pane>
		
			<el-tab-pane label="试题" name="5">
					<el-table :data="ExaminationQuestionsData" border style="width: 100%" :highlight-current-row='true' >
						<el-table-column prop="questionsType" label="题型" width="100" align="center">
							<template #default="scope">
								<span v-if="scope.row.questionsType == 0">单选 </span>
								<span v-if="scope.row.questionsType == 1">多选 </span>
								<span v-if="scope.row.questionsType == 2">判断 </span>
							</template>
						</el-table-column>
						<el-table-column prop="questionsTitle" label="试题名称" width="" align="center"></el-table-column>
						<el-table-column prop="options" label="正确答案" width="" align="center">
							<template #default="scope">
								<div :style="{ color: item.isAnswer ? 'red' : '' }"  v-for="item in scope.row.options" :key="item.id">{{item.answerContent}}</div>
							</template>
						</el-table-column>
						<el-table-column prop="analysis" label="解析" width="" align="center"></el-table-column>
					</el-table>
						<!--底部工具条-->
					<el-col :span="24" class="pageBar" style="margin:20px 0">
						<el-pagination
								@size-change="handleSizeChange5"
								@current-change="handleCurrentChange5"
								:current-page="pages5.pageIndex"
								:page-sizes="pages5.pageArr"
								:page-size="pages5.pageSize"
								layout="total, sizes, prev, pager, next, jumper"
								:total="pages5.dataCount">
						</el-pagination>
					</el-col>

			</el-tab-pane>
				<el-tab-pane label="价格" name="6">
				<el-form :model="productPriceList" label-width="140px">
				<el-form-item label="产品标题："   prop="compilationsHeadline">
					<span>{{productPriceList.headline}}</span>
				</el-form-item>
				<el-form-item label="产品形式："   prop="compilationsHeadline">
					<el-tag v-if='productPriceList.category === 1' type='success'>{{'视频'}}</el-tag>
					<el-tag v-else-if='productPriceList.category === 2' type='success'>{{'word'}}</el-tag>
					<el-tag v-else-if='productPriceList.category === 3' type='success'>{{'ppt'}}</el-tag>
					<el-tag v-else-if='productPriceList.category === 4' type='success'>{{'pdf'}}</el-tag>
				</el-form-item>
				<el-form-item label="产品分类："   prop="compilationsHeadline">
					<span>{{productPriceList.productTypeName}}</span>
				</el-form-item>
				
			</el-form>
			<el-table :data="productPriceList.productFile" border style="width: 100%" :highlight-current-row='true' >
				<el-table-column prop="fileAttribute" label="文件类型" width=""  >
					<template #default='scope'>
						<span v-if='scope.row.fileAttribute === 0' >{{'主体'}}</span>
						<span v-else-if='scope.row.fileAttribute === 1' >{{'调查报告'}}</span>
						<span v-else-if='scope.row.fileAttribute === 2' >{{'判决书'}}</span>
						<span v-else >{{'其它文档'}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="fileName" label="文件名" width=""></el-table-column>
				<el-table-column prop="fileCategory" label="文件格式" width="">
					<template #default='scope'>
						<span v-if='scope.row.fileCategory === 1' >{{'视频'}}</span>
						<span v-else-if='scope.row.fileCategory === 2' >{{'word'}}</span>
						<span v-else-if='scope.row.fileCategory === 3' >{{'ppt'}}</span>
						<span v-else >{{'-'}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="productPriceName" label="观看价格" width="">
					<template #default='scope'>
						<el-input disabled v-if="scope.row.parentId === 0" v-model="scope.row.fileWatchPrice" @change="changePrice" placeholder="请输入价格" style="width: 100%"></el-input>
					</template>
				</el-table-column>
				<el-table-column prop="productPriceName" label="下载价格" width="">
					<template #default='scope'>
						<el-input disabled v-model="scope.row.fileDownloadPrice" @change="changePrice" placeholder="请输入价格" style="width: 100%"></el-input>
					</template>
				</el-table-column>
			</el-table>
			<el-form :model="productPriceList"   label-width="140px">
				<el-form-item label="总价："   prop="compilationsHeadline">
					<span>{{productPriceList.totalPrice}}</span>
				</el-form-item>
				<el-form-item  label="是否热门：" required prop="disasterGrade">
					<el-radio disabled v-model="productPriceList.isHot" :label="true">是</el-radio>
					<el-radio disabled v-model="productPriceList.isHot" :label="false">否</el-radio>
				</el-form-item>
				<el-form-item label="是否免费：" required prop="disasterGrade">
					<el-radio disabled v-model="productPriceList.isFree" :label="true">是</el-radio>
					<el-radio disabled v-model="productPriceList.isFree" :label="false">否</el-radio>
				</el-form-item>
			</el-form>
			</el-tab-pane>
  			</el-tabs>
		</el-dialog>
		
		<!--	点击单品中主体文件弹窗	-->
		<el-dialog
				title= "单品"
				:visible.sync="relatedDialog.productFileCount"
				width="50%"
				:close-on-click-modal='false'
		>
			<el-form :model="addForm"   label-width="140px">
						<el-form-item label="标题"  prop="headline">
							<el-input disabled  v-model="addForm.headline" placeholder="请输入标题" style="width: 50%"></el-input>
						</el-form-item>
						<el-form-item label="编号"  prop="code">
							<el-input disabled v-model="addForm.code" placeholder="请输入标题" style="width: 50%"></el-input>
						</el-form-item>
						<el-form-item label="产品分类："  prop="productTypeId">
							<el-select disabled v-model="addForm.productTypeId" style="width: 50%" placeholder="请选择视频类型" filterable clearable>
								<el-option
										v-for="item in productTypeIdList"
										:key="item.id"
										:label="item.name"
										:value="item.id"
								></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="严重程度："  prop="disasterGrade">
							<el-radio disabled v-model="addForm.disasterGrade" :label="1">较大</el-radio>
							<el-radio disabled v-model="addForm.disasterGrade" :label="2">重大</el-radio>
							<el-radio disabled v-model="addForm.disasterGrade" :label="3">特大</el-radio>
							<el-radio disabled v-model="addForm.disasterGrade" :label="0">一般</el-radio>
						</el-form-item>
						<el-form-item label="所在区域："  prop="provinceId">
							<el-select  placeholder="请选择省" filterable disabled clearable  v-model="addForm.provinceId" @change="selectRowChangeSheng"   >
								<el-option
										v-for="item in shengArr"
										:key="item.id"
										:label="item.name"
										:value="item.id">
								</el-option>
							</el-select>
							<el-select disabled v-model="addForm.cityId" clearable  filterable placeholder="请选择市">
								<el-option
										v-for="item in cityArr"
										:key="item.id"
										:label="item.name"
										:value="item.id">
								</el-option>
							</el-select>
						
						</el-form-item>
						<el-form-item label="火灾日期："  prop="disasterTime">
							<el-date-picker
									disabled
									v-model="addForm.disasterTime"
									type="date"
									value-format="yyyy-MM-dd"
									format="yyyy-MM-dd"
									placeholder="选择日期">
							</el-date-picker>
						</el-form-item>
						
						<el-form-item label="伤亡人数："  prop="casualtiesCount">
							<el-input disabled v-model="addForm.casualtiesCount" placeholder="请输入" style="width: 50%"></el-input>
						</el-form-item>
						<el-form-item label="产品形式："  prop="category">
							<el-radio disabled v-model="addForm.category" :label="1">视频（mp4）</el-radio>
							<el-radio disabled v-model="addForm.category" :label="2">Word（doc/docx）</el-radio>
							<el-radio disabled v-model="addForm.category" :label="3">PPT（ppt/pptx）</el-radio>
							<el-radio disabled v-model="addForm.category" :label="4">游戏</el-radio>
						</el-form-item>
						<div style="margin-bottom: 10px;margin-left: 50px;font-weight: bold;font-size: 16px">
							上传主体文件
						</div>
						<el-form-item label="原始作者："  prop="authorId">
							<el-select disabled v-model="addForm.authorId" style="width: 50%" placeholder="请选择" filterable clearable>
								<el-option
										v-for="item in authorIdList"
										:key="item.id"
										:label="item.name"
										:value="item.id"
								></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="策划："  prop="mastermindId">
							<el-select disabled v-model="addForm.mastermindId" style="width: 50%" placeholder="请选择" filterable clearable>
								<el-option
										v-for="item in authorIdList"
										:key="item.id"
										:label="item.name"
										:value="item.id"
								></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="后期："  prop="anaphaseId">
							<el-select disabled v-model="addForm.anaphaseId"  multiple style="width: 50%" placeholder="请选择" filterable clearable>
								<el-option
										v-for="item in authorIdList"
										:key="item.id"
										:label="item.name"
										:value="item.id"
								></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="封面图片："  prop="firstImageUrl">
							<template>
								<div style="display: flex;justify-content: flex-start;">
									<div class="avatar-uploader">
										<img  :src="addForm.firstImageUrl" class="avatar" />
									</div>
									<div  class="avatar-uploader3" style="margin-left: 20px">
										<img  :src="addForm.verticalImageUrl" class="avatar3" />
									</div>
								</div>
							</template>
						</el-form-item>
						<el-form-item  prop="productIntroduce"  label="简介：">
							<el-input disabled v-model="addForm.productIntroduce" type="textarea" rows="3"  style="width: 50%"></el-input>
						</el-form-item>
						<el-form-item  prop="productTagId"  label="标签：">
							<el-select disabled v-model="addForm.productTagId" multiple style="width: 50%" placeholder="请选择" filterable clearable>
								<el-option
										v-for="item in tagTypeIdList"
										:key="item.id"
										:label="item.name"
										:value="item.id"
								></el-option>
							</el-select>
						</el-form-item>
					</el-form>
		</el-dialog>
		
		<!--	点击单品中列表调查报告弹窗	-->
		<el-dialog
				title= "单品"
				:visible.sync="relatedDialog.productFileInvestigationCount"
				width="50%"
				:close-on-click-modal='false'
				destroy-on-close
		>
			<el-form :model="addForm"   label-width="140px">
				<el-form-item label="标题："  :rules="{ required: true, message: '标题不能为空', trigger: 'blur'}" prop="compilationsHeadline">
					<el-input disabled v-model="addForm.headline"   style="width: 50%"></el-input>
				</el-form-item>
				<div style="margin: 20px">上传判决书/调查报告/其它文档</div>
				<el-form-item label="原始作者：" required prop="authorId">
					<el-select v-model="addForm.authorId" style="width: 50%" @change="changeAuthor" placeholder="请选择" filterable clearable>
						<el-option
								v-for="item in authorIdList"
								:key="item.id"
								:label="item.name"
								:value="item.id"
						></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="产品形式：" required prop="category">
					<template #default='scope'>
						<el-radio-group v-model="addForm.category" @change="changeCategory">
							<el-radio :label="1">视频（mp4）</el-radio>
							<el-radio :label="2">Word（doc/docx）</el-radio>
							<el-radio :label="3">PPT（ppt/pptx）</el-radio>
							<el-radio :label="4">PDF</el-radio>
						</el-radio-group>
					</template>
				</el-form-item>
				<el-form-item   prop="fileId" label="上传文件：" v-if="selsetCategory===1">
					<template>
						<div class="hello">
							<div>
								<input type="file" class="upload" @change="doUpload" ref="inputer" />
							</div>
							<div>
								<el-table :data="tableData1" border style="width: 100%">
									<el-table-column prop="fileName" label="文件名" width="">
									</el-table-column>
									<el-table-column prop="size" label="文件大小" width="120">
										<template slot-scope="scope">{{ transformSize(scope.row.fileSize)}}</template>
									</el-table-column>
									<el-table-column prop="progress" label="进度" width="180">
										<template slot-scope="scope">
											<el-progress :text-inside="true" :stroke-width="26" :percentage="scope.row.progress"></el-progress>
										</template>
									
									</el-table-column>
									<el-table-column prop="progress" label="操作" width="160">
										<template slot-scope="scope" >
											<el-button type="text" size="small" @click="start(scope.row.id)">开始</el-button>
											<el-button type="text" size="small" @click="stop(scope.row.id)">暂停</el-button>
											<el-button type="text" size="small" @click="remove(scope.row.id)">删除</el-button>
										</template>
									</el-table-column>
								</el-table>
							</div>
						</div>
					</template>
				</el-form-item>
				<el-form-item  prop="productName"  label="上传文档：" v-else>
					<el-upload
							:action="actionUrlFile"
							:headers="headers"
							:data="uploadDataFile"
							:before-upload="beforeUpload_file"
							:on-success="handle_success_file"
							 :before-remove="beforeRemove"
							:show-file-list="true"
							:limit="5"
							:file-list="fileList"
					>
						<el-button size="small" type="primary">点击上传</el-button>
					</el-upload>
				</el-form-item>
			</el-form>
			<span  slot="footer" class="dialog-footer">
          <el-button type="primary" @click="closeDialog">关闭</el-button>
      </span>
		</el-dialog>
		
		<!--点击单品中列表判决书弹窗-->
		<el-dialog
				title= "单品"
				:visible.sync="relatedDialog.productFileJudgementCount"
				width="50%"
				:close-on-click-modal='false'
				destroy-on-close
		>
			<el-form :model="addForm"   label-width="140px">
				<el-form-item label="标题："  :rules="{ required: true, message: '标题不能为空', trigger: 'blur'}" prop="compilationsHeadline">
					<el-input disabled v-model="addForm.headline"   style="width: 50%"></el-input>
				</el-form-item>
				<div style="margin: 20px">上传判决书/调查报告/其它文档</div>
				<el-form-item label="原始作者：" required prop="authorId">
					<el-select v-model="addForm.authorId" style="width: 50%" @change="changeAuthor" placeholder="请选择" filterable clearable>
						<el-option
								v-for="item in authorIdList"
								:key="item.id"
								:label="item.name"
								:value="item.id"
						></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="产品形式：" required prop="category">
					<template #default='scope'>
						<el-radio-group v-model="addForm.category" @change="changeCategory">
							<el-radio :label="1">视频（mp4）</el-radio>
							<el-radio :label="2">Word（doc/docx）</el-radio>
							<el-radio :label="3">PPT（ppt/pptx）</el-radio>
							<el-radio :label="4">PDF</el-radio>
						</el-radio-group>
					</template>
				</el-form-item>
				<el-form-item   prop="fileId" label="上传文件：" v-if="selsetCategory===1">
					<template>
						<div class="hello">
							<div>
								<input type="file" class="upload" @change="doUpload" ref="inputer"  />
							</div>
							
							<div>
								<el-table :data="tableData1" border style="width: 100%">
									<el-table-column prop="fileName" label="文件名" width="">
									</el-table-column>
									<el-table-column prop="size" label="文件大小" width="120">
										<template slot-scope="scope">{{ transformSize(scope.row.fileSize)}}</template>
									</el-table-column>
									<el-table-column prop="progress" label="进度" width="180">
										<template slot-scope="scope">
											<el-progress :text-inside="true" :stroke-width="26" :percentage="scope.row.progress"></el-progress>
										</template>
									
									</el-table-column>
									<el-table-column prop="progress" label="操作" width="160">
										<template slot-scope="scope" >
											<el-button type="text" size="small" @click="start(scope.row.id)">开始</el-button>
											<el-button type="text" size="small" @click="stop(scope.row.id)">暂停</el-button>
											<el-button type="text" size="small" @click="remove(scope.row.id)">删除</el-button>
										</template>
									</el-table-column>
								</el-table>
							</div>
						</div>
					</template>
				</el-form-item>
				<el-form-item  prop="productName"  label="上传文档：" v-else>
					<el-upload
							:action="actionUrlFile"
							:headers="headers"
							:data="uploadDataFile"
							:before-upload="beforeUpload_file"
							:on-success="handle_success_file"
							 :before-remove="beforeRemove"
							:show-file-list="true"
							:limit="5"
							:file-list="fileList"
					>
						<el-button size="small" type="primary">点击上传</el-button>
					</el-upload>
				</el-form-item>
			</el-form>
			<span  slot="footer" class="dialog-footer">
          <el-button type="primary" @click="relatedDialog.productFileJudgementCount=false;">关闭</el-button>
      </span>
		</el-dialog>
		
		<!--点击单品中列表其它文档弹窗-->
		<el-dialog
				title= "单品"
				:visible.sync="relatedDialog.productFileOtherCount"
				width="50%"
				:close-on-click-modal='false'
				destroy-on-close
		>
			<el-form :model="addForm"   label-width="140px">
						<el-form-item label="标题："  :rules="{ required: true, message: '标题不能为空', trigger: 'blur'}" prop="compilationsHeadline">
							<el-input disabled v-model="addForm.headline"   style="width: 50%"></el-input>
						</el-form-item>
						<div style="margin: 20px">上传判决书/调查报告/其它文档</div>
						<el-form-item label="原始作者：" required prop="authorId">
							<el-select v-model="addForm.authorId" style="width: 50%" @change="changeAuthor" placeholder="请选择" filterable clearable >
								<el-option
										v-for="item in authorIdList"
										:key="item.id"
										:label="item.name"
										:value="item.id"
								></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="产品形式：" required prop="category">
							<template #default='scope'>
								<el-radio-group v-model="addForm.category" @change="changeCategory">
									<el-radio :label="1">视频（mp4）</el-radio>
									<el-radio :label="2">Word（doc/docx）</el-radio>
									<el-radio :label="3">PPT（ppt/pptx）</el-radio>
									<el-radio :label="4">PDF</el-radio>
								</el-radio-group>
							</template>
						</el-form-item>
						<el-form-item  required prop="fileId" label="上传文件：" v-if="selsetCategory===1">
							<template>
								<div class="hello">
									<div>
										<input type="file" class="upload" @change="doUpload" ref="inputer"   />
									</div>
									
									<div >
										<el-table :data="tableData1" border style="width: 100%">
											<el-table-column prop="fileName" label="文件名" width="">
											</el-table-column>
											<el-table-column prop="size" label="文件大小" width="120">
												<template slot-scope="scope">{{ transformSize(scope.row.fileSize)}}</template>
											</el-table-column>
											<el-table-column prop="progress" label="进度" width="180">
												<template slot-scope="scope">
													<el-progress :text-inside="true" :stroke-width="26" :percentage="scope.row.progress"></el-progress>
												</template>
											
											</el-table-column>
											<el-table-column prop="progress" label="操作" width="160">
												<template slot-scope="scope" >
													<el-button type="text" size="small" @click="start(scope.row.id)" >开始</el-button>
													<el-button type="text" size="small" @click="stop(scope.row.id)" >暂停</el-button>
													<el-button type="text" size="small" @click="remove(scope.row.id)" >删除</el-button>
												</template>
											</el-table-column>
										</el-table>
									</div>
								</div>
							</template>
						</el-form-item>
						<el-form-item  prop="productName" required label="上传文档：" v-else>
							<el-upload
									:action="actionUrlFile"
									:headers="headers"
									:data="uploadDataFile"
									:before-upload="beforeUpload_file"
									:on-success="handle_success_file"
									:show-file-list="true"
									:before-remove="beforeRemove"
									:limit="5"
									:file-list="fileList"
							>
								<el-button  size="small" type="primary">点击上传</el-button>
							</el-upload>
						</el-form-item>
					</el-form>
		</el-dialog>
		
		<!--点击单品中列表相关资料弹窗-->
		<el-dialog
				title= "单品"
				:visible.sync="relatedDialog.productFileRelatedCount"
				width="50%"
				:close-on-click-modal='false'
		>
			<el-form :model="addForm"  label-width="140px">
				<el-form-item label="标题："  :rules="{ required: true, message: '标题不能为空', trigger: 'blur'}" prop="compilationsHeadline">
					<el-input disabled v-model="addForm.headline"   style="width: 50%"></el-input>
				</el-form-item>
				<div style="margin: 20px">上传判决书/调查报告/其它文档</div>
				<el-form-item label="原始作者：" required prop="authorId">
					<el-select v-model="addForm.authorId" disabled style="width: 50%" placeholder="请选择" filterable clearable>
						<el-option
								v-for="item in authorIdList"
								:key="item.id"
								:label="item.name"
								:value="item.id"
						></el-option>
					</el-select>
				</el-form-item>
				
				<el-form-item  required prop="fileId" label="上传文件：">
					<template>
						<div class="hello">
							<div>
								<el-table :data="tableData1" border style="width: 100%">
									<el-table-column prop="fileName" label="文件名" width="">
									</el-table-column>
									<el-table-column prop="type" label="类型" width="120">
									</el-table-column>
									<el-table-column prop="size" label="文件大小" width="120">
										<template slot-scope="scope">{{ transformSize(scope.row.fileSize)}}</template>
									</el-table-column>
									<el-table-column prop="progress" label="进度" width="180">
										<template slot-scope="scope">
											<el-progress :text-inside="true" :stroke-width="26" :percentage="scope.row.progress"></el-progress>
										</template>
									
									</el-table-column>
								</el-table>
							</div>
						</div>
					</template>
				</el-form-item>
			</el-form>
			<span  slot="footer" class="dialog-footer">
          <el-button type="primary" @click="relatedDialog.productFileRelatedCount = false">关闭</el-button>
      </span>
		</el-dialog>
		
		<!--点击单品中总价弹窗-->
		<el-dialog
				title= "单品"
				:visible.sync="relatedDialog.productFileTotalPrice"
				width="50%"
				:close-on-click-modal='false'
		>
			<el-form :model="productPriceList"  label-width="140px">
				<el-form-item label="产品标题："   prop="compilationsHeadline">
					<span>{{productPriceList.headline}}</span>
				</el-form-item>
				<el-form-item label="产品形式："   prop="compilationsHeadline">
					<el-tag v-if='productPriceList.category === 1' type='success'>{{'视频'}}</el-tag>
					<el-tag v-else-if='productPriceList.category === 2' type='success'>{{'word'}}</el-tag>
					<el-tag v-else-if='productPriceList.category === 3' type='success'>{{'ppt'}}</el-tag>
					<el-tag v-else-if='productPriceList.category === 4' type='success'>{{'pdf'}}</el-tag>
				</el-form-item>
				<el-form-item label="产品分类："   prop="compilationsHeadline">
					<span>{{productPriceList.productTypeName}}</span>
				</el-form-item>
				
			</el-form>
			<el-table :data="productPriceList.productFile" border style="width: 100%" :highlight-current-row='true' >
				<el-table-column prop="fileAttribute" label="文件类型" width=""  >
					<template #default='scope'>
						<span v-if='scope.row.fileAttribute === 0' >{{'主体'}}</span>
						<span v-else-if='scope.row.fileAttribute === 1' >{{'调查报告'}}</span>
						<span v-else-if='scope.row.fileAttribute === 2' >{{'判决书'}}</span>
						<span v-else >{{'其它文档'}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="fileName" label="文件名" width=""></el-table-column>
				<el-table-column prop="fileCategory" label="文件格式" width="">
					<template #default='scope'>
						<span v-if='scope.row.fileCategory === 1' >{{'视频'}}</span>
						<span v-else-if='scope.row.fileCategory === 2' >{{'word'}}</span>
						<span v-else-if='scope.row.fileCategory === 3' >{{'ppt'}}</span>
						<span v-else >{{'-'}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="productPriceName" label="观看价格" width="">
					<template #default='scope'>
						<div v-if="scope.row.parentId === 0" style="display:flex;align-items:center;">
							<el-input v-if="scope.row.parentId === 0" v-model="scope.row.fileWatchPrice" @change="changePrice" placeholder="请输入价格" style="width: 100%"></el-input>
							<span style="color:red;margin-left:3px;">元</span>
						</div>
						
					</template>
				</el-table-column>
				<el-table-column prop="productPriceName" label="下载价格" width="">
					<template #default='scope'>
						<div style="display:flex;align-items:center;">
							<el-input v-model="scope.row.fileDownloadPrice" @change="changePrice" placeholder="请输入价格" style="width: 100%"></el-input>
							<span style="color:red;margin-left:3px;">元</span>
						</div>
					</template>
				</el-table-column>
			</el-table>
			<el-form :model="productPriceList"  label-width="140px">
				<el-form-item label="总价："  prop="compilationsHeadline">
					<span>{{productPriceList.totalPrice}}</span><span style="color:red;margin-left:3px;">元</span>
				</el-form-item>
				<el-form-item label="是否热门：" required prop="disasterGrade">
					<el-radio v-model="productPriceList.isHot" :label="true">是</el-radio>
					<el-radio v-model="productPriceList.isHot" :label="false">否</el-radio>
				</el-form-item>
				<el-form-item label="是否免费：" required prop="disasterGrade">
					<el-radio v-model="productPriceList.isFree" :label="true">是</el-radio>
					<el-radio v-model="productPriceList.isFree" :label="false">否</el-radio>
				</el-form-item>
			</el-form>
			<span  slot="footer" class="dialog-footer">
          <el-button @click="relatedDialog.productFileTotalPrice = false">取 消</el-button>
          <el-button type="primary" @click="productFileTotalPriceConfirm" :loading="listLoading">确认</el-button>
      </span>
		</el-dialog>
		<!--点击合集中总价弹窗	-->
		<el-dialog
				title= "合集"
				:visible.sync="collectionDialog.totalPrice"
				width="50%"
				:close-on-click-modal='false'
		>
			<el-form :model="productPriceList"   label-width="140px">
				<el-form-item label="产品标题："   prop="compilationsHeadline">
					<span>{{productPriceList.compilationsHeadline}}</span>
				</el-form-item>
				<el-form-item label="产品分类："   prop="productTypeName">
					<span>{{productPriceList.productTypeName}}</span>
				</el-form-item>
			
			</el-form>
			<el-table :data="productPriceList.productFile" border style="width: 100%"  :highlight-current-row='true'  >
				<el-table-column prop="headline" label="单品标题" width="340px" size="medium"></el-table-column>
				<el-table-column prop="category" label="主体文件格式" width="">
				</el-table-column>
				<el-table-column prop="productFileLookPrice" label="观看价格" width="">
				</el-table-column>
				<el-table-column prop="productFileDownloadPrice" label="下载价格" width="">
				</el-table-column>
				<el-table-column prop="productFileAttachmentTotalPrice" label="其他文档价格" width="">
				</el-table-column>
				<el-table-column prop="productFileTotalPrice" label="总价" width="">
				</el-table-column>
			</el-table>
			<el-form :model="productPriceList"  label-width="140px">
				<el-form-item label="原总价："   prop="compilationsHeadline">
					<span>{{productPriceList.totalPrice}}</span>
				</el-form-item>
				<el-form-item label="折扣比例："  prop="disasterGrade">
					<el-select v-model="productPriceList.discountPercentage" @change="changeDiscount" placeholder="请选择">
						<el-option
								v-for="item in options"
								:key="item.value"
								:label="item.label"
								:value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="折扣总价：" required  prop="compilationsPrice">
					<span>{{productPriceList.compilationsPrice}}</span>
				</el-form-item>
				<el-form-item label="是否热门：" required prop="disasterGrade">
					<el-radio v-model="productPriceList.isHot" :label="true">是</el-radio>
					<el-radio v-model="productPriceList.isHot" :label="false">否</el-radio>
				</el-form-item>
				<el-form-item label="是否免费：" required prop="disasterGrade">
					<el-radio v-model="productPriceList.isFree" :label="true">是</el-radio>
					<el-radio v-model="productPriceList.isFree" :label="false">否</el-radio>
				</el-form-item>
			</el-form>
			<span  slot="footer" class="dialog-footer">
				<el-button @click="collectionDialog.totalPrice = false">取 消</el-button>
				<el-button type="primary" @click="collectionTotalPriceConfirm" :loading="listLoading">确认</el-button>
      		</span>
		</el-dialog>
		<el-dialog
				title= "预览"
				:visible.sync="dialogs.addType.firurl"
				width="50%"
				:show-close = false
		>
			<template >
				<div id="player"></div>
			</template>
			<span  slot="footer" class="dialog-footer">
		    <el-button type="primary" @click="closePreview" :loading="listLoading">关闭</el-button>
	    </span>
		</el-dialog>


		<!--点击配置试题弹窗-->
		<el-dialog
				title= "配置试题"
				:visible.sync="ConfigurationExamQuestionsdialog"
				width="50%"
				:close-on-click-modal='false'
		>
		<div>
			<el-row>
			<el-col>
				<el-form :inline='true' :model="filters2">
					<el-form-item label="" >
						<el-input v-model="filters2.keyWord" clearable placeholder="请输入题号/试题名称" width="120px"></el-input>
					</el-form-item>
					<el-form-item label="">
						<el-select v-model="filters2.questionsType" style="width: 160px" placeholder="题型" filterable clearable>
							<el-option
									v-for="item in questionsTypeList"
									:key="item.id"
									:label="item.name"
									:value="item.id"
							></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="">
						<el-select v-model="filters2.relationCount" style="width: 160px" placeholder="关联次数" filterable clearable>
							<el-option
									v-for="item in relationCountList"
									:key="item.id"
									:label="item.name"
									:value="item.name"
							></el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="queryquestionsListFun">查询</el-button>
						<el-button type="primary" @click="importExaminationQuestionsFun">导入</el-button>
						<!-- <el-button type="primary" @click="relateQuestionsFun">关联试题</el-button> -->
					</el-form-item>
				</el-form>
			</el-col>
		</el-row>
			<el-table
					:data="ExaminationQuestions"
					border
					style="width: 100%;"
					v-loading="listLoading"
			>
				<el-table-column>
				<template #default="scope">
					<el-checkbox 
						v-model="scope.row.isRelation" 
						@change="handleCustomSelectionChange(scope.row)">
					</el-checkbox>
        		</template>
				</el-table-column>
				<el-table-column prop="questionsCode" label="题号"  width='' align="center" ></el-table-column>
				<el-table-column prop="" label="题型"  width='' align="center" >
					<template #default="scope">
						<span v-if="scope.row.questionsType == 0">单选 </span>
						<span v-if="scope.row.questionsType == 1">多选 </span>
						<span v-if="scope.row.questionsType == 2">判断 </span>

					</template>
				</el-table-column>
				<el-table-column prop="questionsTitle" label="试题名称"  width='' align="center" ></el-table-column>
				<el-table-column prop="createTime" label="试题更新时间"  width='' align="center" ></el-table-column>
				<el-table-column prop="relationCount" label="关联次数"  width='' align="center" ></el-table-column>
			</el-table>
			<div style="margin-top:20px">
				<el-pagination
								@size-change="handleSizeChange3"
								@current-change="handleCurrentChange3"
								:current-page="pages3.pageIndex"
								:page-sizes="pages3.pageArr"
								:page-size="pages3.pageSize"
								layout="total, sizes, prev, pager, next, jumper"
								:total="pages3.dataCount">
								
				</el-pagination>
			</div>
			</div>
		</el-dialog>

		<!--导入试题弹窗-->
		<el-dialog
				title= "导入题库"
				:visible.sync="importQuestionsdialog"
				width="50%"
				:close-on-click-modal='false'
		>
		  <el-form
        :model="importQuestionsForm"
        label-width="100px"
        ref="importPhoneForm"
        style="max-width: 700px"
      >
       
        <!-- 上传区域 -->
        <el-form-item label="导入题库: ">
          <el-upload
            ref="importQuestionsupload"
            action=""
            :on-change="handleFileChange"
            :before-upload="beforeUpload"
            :auto-upload="false"
            :show-file-list="true"
            accept=".xls,.xlsx"
          >
            <el-button slot="trigger" size="small" type="primary"
              >选择导入文件(Excel)</el-button
            >
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="importQuestionsdialog = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="importQuestionsSubmit"
          :loading="listLoading"
          >提交</el-button
        >
      </div>
	</el-dialog>


	<!-- 点击试题数量弹窗 -->
		<el-dialog
				title= "试题维护"
				:visible.sync="questionMaintenanceDialog"
				width="50%"
				:close-on-click-modal='false'
		>
		<div>
				<el-button style="margin-bottom:10px;" type="primary" @click="addExamQuestion">新增试题</el-button>

				<el-table :data="ExaminationQuestionsData" border style="width: 100%" :highlight-current-row='true' >
						<el-table-column prop="questionsType" label="题型" width="100" align="center">
							<template #default="scope">
								<span v-if="scope.row.questionsType == 0">单选 </span>
								<span v-if="scope.row.questionsType == 1">多选 </span>
								<span v-if="scope.row.questionsType == 2">判断 </span>
							</template>
						</el-table-column>
						<el-table-column prop="questionsTitle" label="试题名称" width="" align="center"></el-table-column>
						<el-table-column prop="options" label="正确答案" width="" align="center"> 
							<template #default="scope">
								<div :style="{ color: item.isAnswer ? 'red' : '' }"  v-for="item in scope.row.options" :key="item.id">{{item.answerContent}}</div>
							</template>
						</el-table-column>
						<el-table-column prop="analysis" label="解析" width="" align="center"></el-table-column>
						<el-table-column
							fixed="right"
							label="操作"
							width="100"
							align="center">
							<template slot-scope="scope">
								<el-button @click="handleDelete(scope.row)" type="text" size="small">删除</el-button>
							
							</template>
							</el-table-column>
					</el-table>
					<div style="margin-top:20px">
						<el-pagination
										@size-change="handleSizeChange4"
										@current-change="handleCurrentChange4"
										:current-page="pages4.pageIndex"
										:page-sizes="pages4.pageArr"
										:page-size="pages4.pageSize"
										layout="total, sizes, prev, pager, next, jumper"
										:total="pages4.dataCount">
										
						</el-pagination>
					</div>
		</div>
		</el-dialog>



	<!--发布弹窗-->
		<el-dialog title="产品发布" :visible.sync="publishDialog" width="30%">
			<div style="text-align: center;font-size: 18px" >
				<div>
					{{'产品标题：'}}
					<el-button type="text">
  							{{ needData ? (activeName=='first' ? needData.headline : needData.compilationsHeadline) : '暂无数据' }}
					</el-button>
				</div>
				<div>
					{{'确定要发布产品吗？'}}
				</div>
				<div style="height: 30px"></div>
				<div>
					<el-button @click="publishDialog = false">取消操作</el-button>
					<el-button type="primary" @click="publishConfirm">确定发布</el-button>
				</div>
			</div>
		</el-dialog>
		<!--置顶弹窗-->
		<el-dialog title="产品是否置顶？" :visible.sync="topDialog" width="30%">
			<div style="text-align: center;font-size: 18px" >
				<div>
					{{'产品标题：'}}
					<el-button type="text">
  							{{ needData ? (activeName=='first' ? needData.headline : needData.compilationsHeadline) : '暂无数据' }}
					</el-button>
				</div>
				<div>
					{{'产品是否置顶？'}}
				</div>
				<div style="height: 30px"></div>
				<div>
					<el-button @click="topCancle">取消置顶</el-button>
					<el-button type="primary" @click="topConfirm">确定置顶</el-button>
				</div>
			</div>
		
		</el-dialog>
	</div>
</template>

<script>
import util from "../../../util/date";
import Toolbar from "../../components/Toolbar";
import { getButtonList } from "../../promissionRouter";
import { useEnterSearch, removeEnterSearch } from '../../../util/enterSearch';
// 修改点：引入 axios 用于发送文件上传请求
import axios from "axios";
import {
	updateProductCompilationsData,
	getVideoUploadParams,
	updateVideoManage,
	getProductListPage,
	getByDataCode,
	getAreaDictionaryList,
	addProductData,
	addFileByCode,
	uploadTempPic,
	getProductList,
	addProductCompilationsData,
	getProductCompilationsListPage,
	getProductIdListData,
	getUserInfoList,
	getProductIdFileListAttachmentData,
	deleteProductFileIdAttachment,
	updateProductData,
	deleteProductId,
	deleteProductCompilationsId,
	updateProductFilePrice,
	updateProductStatus,
	updateProductIdTop,
	updateProductCompilationsStatus,
	updateProductCompilationsTop,
	uploadProductDownloadFile, uploadDocumentFile, getUploadDocumentFile,
	getExaminationQuestionsListPage,
	importExaminationQuestionsApi,
	addProductQuestionsRelationApi,
	deleteProductQuestionsRelationApi,
	getProductCompilationsIdListData
} from '../../api/api'
import Sortable from 'sortablejs';
import PlvVideoUpload from '@polyv/vod-upload-js-sdk';

export default {
	components:{Toolbar},
	data() {
		// 创建 options 数组，包含从 20% 到 100% 的选项（每次增加 5%）
		const options = [];
		for (let i = 20; i <= 100; i += 5) {
			options.push({
				label: `${i}%`,
				value: i
			});
		}
		// 自定义校验函数
		const validateImages = (rule, value, callback) => {
			if (!this.addForm.firstImageUrl) {
			callback(new Error('请上传横版封面图片(推荐比例16:9)'));
			} else if (!this.addForm.verticalImageUrl) {
			callback(new Error('请上传竖版封面图片(推荐比例3:4)'));
			} else {
			callback();
			}
		};
		// 自定义视频验证
		const validateVideo = (rule, value, callback) => {
			console.log("this.tableData1",this.tableData1)
			if (!this.tableData1 || this.tableData1.length === 0) {
				return callback(new Error('请上传视频文件'));
			}
		  	// 2. 检查 tableData1 中的每一项 progress 是否都为 100
			const allProgressComplete = this.tableData1.every(item => item.progress === 100);
			
			if (!allProgressComplete) {
				return callback(new Error('上传视频到保利威服务器中，请等待上传完成'));
			}
		
			// 3. 检查 addForm.fileUrl 是否存在
			if (!this.addForm.fileUrl) {
				return callback(new Error('上传视频到服务器中，请等待上传完成'));
			}
			
			callback();
		};
		// 自定义验证文档
		const documentValidator = (rule, value, callback) => {
			 if (!this.fileList || this.fileList.length === 0) {
            return callback(new Error('请上传文档文件'));
          }
			// 如果不是视频类型，直接通过验证
			callback();
		};

		// 校验是否关联单品
		const validaterelatedTableData =(rule, value, callback) => {
			 if (!this.relatedTableData || this.relatedTableData.length === 0) {
            return callback(new Error('请关联单品'));
          }
			// 如果不是视频类型，直接通过验证
			callback();
		};

		return {
			selsetCategory:1,
			productTypeIdChildList: [],
			options,
			topDialog:false,
			needData:undefined,
			authorIdList: [],
			collectionDialog:{
				compilationsHeadline:false,//产品标题,
				totalPrice:false,//总价
			},
			collectionNameDialogData:[],
			relatedTableData:[],//关联单品列表
			relatedListLoading:false,//关联单品列表加载中
			relatedSelectionListLoading:false,//选择关联单品列表加载中
			relatedSelectionTableData: [],//选择关联单品列表
			relatedDialogList:false,
			productPriceList:{},
			relatedDialog:{
				headline:false,
				productFileCount:false,//主题文件
				productFileInvestigationCount:false,//调查报告
				productFileJudgementCount:false,//判决书
				productFileOtherCount:false,//其它文档
				productFileRelatedCount:false,//相关资料
				productFileTotalPrice:false,//总价
			},
			relatedDataList:{
				headline:[],//名称
				productFileCount:[],//主题文件
				productFileInvestigationCount:[],//调查报告
				productFileJudgementCount:[],//判决书
				productFileOtherCount:[],//其它文档
				productFileRelatedCount:[],//相关资料
				productFileTotalPrice:[],//总价
			},
			activeName: 'first',
			imageUrlData:'',
			actionUrl:undefined,
			actionUrlFile:undefined,
			uploadDataFile:{},
			statusList:[
					{name:'未发布',id:0},
					{name:'已发布',id:1},
					{name:'已下架',id:3},
					{name:'维护中',id:4}

			],
			categoryList:[
					{name:'视频',id:1},
					{name:'word',id:2},
					{name:'ppt',id:3},
					{name:'pdf',id:4},
			],
			productTypeIdList:[],
			buttonList:[],
			tableData: [],
			tableData2:[],
			tableData1: [],
			tableData3:[],
			listLoading: false,
			//关于分页的obj
			pages: {
				pageSize: 20,//默认每页条数
				pageArr: [10, 20, 30, 40],//默认每页条数选择
				pageIndex: 1, //默认进入页
				dataCount: 20, //默认总页数
			},
			//关于分页的obj
			pages1: {
				pageSize: 20,//默认每页条数
				pageArr: [10, 20, 30, 40],//默认每页条数选择
				pageIndex: 1, //默认进入页
				dataCount: 20, //默认总页数
			},
			//关于分页的obj
			pages2: {
				pageSize: 20,//默认每页条数
				pageArr: [10, 20, 30, 40],//默认每页条数选择
				pageIndex: 1, //默认进入页
				dataCount: 20, //默认总页数
			},
			//关于分页的obj
			pages3: {
				pageSize: 20,//默认每页条数
				pageArr: [10, 20, 30, 40],//默认每页条数选择
				pageIndex: 1, //默认进入页
				dataCount: 20, //默认总页数
			},
			//关于分页的obj
			pages4: {
				pageSize: 20,//默认每页条数
				pageArr: [10, 20, 30, 40],//默认每页条数选择
				pageIndex: 1, //默认进入页
				dataCount: 20, //默认总页数
			},
			pages5: {
				pageSize: 20,//默认每页条数
				pageArr: [10, 20, 30, 40],//默认每页条数选择
				pageIndex: 1, //默认进入页
				dataCount: 20, //默认总页数
			},
			
			filters: {
				headlineOrCode:undefined,//标题或者编号
				category:undefined,//产品形式（主体文件格式：1视频、2word、3ppt）
				productTypeId:undefined,//产品分类
				status:undefined,//发布状态：0未发布、1已发布、3已下架
				releaseTime:undefined,//发布日期
			},
	
			dialogs:{
				addType:{
					dialog:false,
					firurl:false,
				},
				addCollection:{
					dialog:false,
				}
			},
			needDataPhoto:undefined,
			tagTypeIdList:undefined,
			addForm:{
				productTypeSecondId:undefined,//产品分类二级id（数据字典id）
				verticalImageUrl:'',//产品首图竖
				provinceId:undefined,//省
				cityId:undefined,//市
				id:undefined,
				code:undefined,//编号
				headline:undefined,//产品标题
				category:1,//产品形式（主体文件格式：1视频、2word、3ppt）
				productTypeId:undefined,//产品分类id（数据字典id）
				disasterGrade	:undefined,//严重程度（0一般、1较大、2重大、3特大）
				disasterTime:undefined,//火灾日期
				casualtiesCount:undefined,//伤亡人数
				productTagId:[],//产品标签
				authorId:undefined,//原始作者用户Id（单）
				mastermindId:undefined,//策划Id（单）
				anaphaseId:undefined,//后期Id（多）
				productFileId:undefined,//主体文件Id
				isFree:undefined,//是否免费
				isTop:undefined,//是否置顶
				isHot:undefined,//是否热门
				productIntroduce:undefined,//产品简介
				firstImageUrl:'',//产品首图
				status:undefined,//发布状态：0未发布、1已发布、3已下架
				issuerId:undefined,//发布人id
				compilationsCoverImage:'',//产品合集封面图片
				compilationsHeadline:undefined,//产品名称
				compilationsCode:undefined,//产品合集编号
				productsIdList:[],//产品合集产品IdList,
				fileUrl:'',
				isPerfect:undefined,
			},
			addFormRules: {
				headline: [
						{ required: true, message: '请输入产品标题', trigger: 'blur' },
				],
				code: [
					{ required: true, message: '请输入编号', trigger: 'blur' },
				],
				productTypeId: [
					{ required: true, message: '请选择产品分类', trigger: 'blur' },
				],
				productTypeSecondId:[
					{ required: true, message: '请选择二级分类', trigger: 'blur' },
				],
				isPerfect: [
						{ required: true, message: '请选择主体是否完善', trigger: 'blur' },
				],
				disasterGrade: [
					{ required: true, message: '请选择严重程度', trigger: 'blur' },
				],
				provinceId: [
					{ required: true, message: '请选择省', trigger: 'blur' },
				],
				cityId: [
						{ required: true, message: '请选择市', trigger: 'blur' },
				],
				disasterTime: [
						{ required: true, message: '请选择火灾日期', trigger: 'blur' },
				],
				casualtiesCount: [
					{ required: true, message: '请输入伤亡人数', trigger: 'blur' },
				],
				category: [
					{ required: true, message: '请选择产品形式', trigger: 'blur' },
				],
				authorId: [
					{ required: true, message: '请选择原始作者用户', trigger: 'blur' },
				],
				mastermindId: [
						{ required: true, message: '请选择策划', trigger: 'blur' },
				],
				anaphaseId: [
					{ required: true, message: '请选择后期', trigger: 'blur' },
				],
				
				firstImageUrl: [
						 { required: true, validator: validateImages, trigger: 'change' }
				],
					
				productFileId: [
						{ required: true, validator: validateVideo, trigger: 'change' },
				],
				productName:[
					{ required: true,  validator: documentValidator,trigger: 'change' },
				],
				productIntroduce: [
						{ required: true, message: '请输入产品简介', trigger: 'blur' },
				],
				productTagId: [
						{ required: true, message: '请选择产品标签', trigger: 'blur' },
				],
				
			},
			addFormRules2: {
				compilationsHeadline: [
						{ required: true, message: '请输入产品标题', trigger: 'blur' },
				],
				compilationsCode: [
					{ required: true, message: '请输入产品编号', trigger: 'blur' },
				],
				category: [
					{ required: true, message: '请选择产品形式', trigger: 'blur' },
				],
				productTypeId: [
					{ required: true, message: '请选择产品分类', trigger: 'blur' },
				],
				productTypeSecondId:[
					{ required: true, message: '请选择二级分类', trigger: 'blur' },
				],
				compilationsCoverImage: [
						{ required: true, message: '请选择合集封面', trigger: 'blur' },
				],
				relatedTableData: [
					{ required: true,validator: validaterelatedTableData, trigger: 'blur' },
				]
			},
			editFalse:false,
			fileList:undefined,
			vodPlayerJs: "https://player.polyv.net/resp/vod-player/latest/player.js",
			previewBlooean:false,
			fileSetting: {
				desc: '测试视频上传', // 描述
				cataid: 1748419679001, // 分类ID 可以后端传递 也可以不写 或写死
				tag: 'tag', // 标签
				luping: 0, // 是否开启视频课件优化处理，对于上传录屏类视频清晰度有所优化：0为不开启，1为开启
				keepsource: 1 // 是否源文件播放（不对视频进行编码）：0为编码，1为不编码
			},
			videoUpload: null, // 视频上传实例
			fileUpload:undefined,
			shengArr:[],
			cityArr:[],
			multipleSelection: [],
			fileAttribute:undefined,
			fileCategory:undefined,
			parentId:undefined,
			publishDialog:false,
			activetagIndex:"1",
			needData2:[],
			// 点击配置试题弹窗
			ConfigurationExamQuestionsdialog:false,
			filters2: {
				keyWord:undefined,
				questionsType:undefined,
				relationCount:undefined,
				// releaseTime:undefined,
				productId:undefined
			},
			questionsTypeList:[
				{
					id:0,
					name:'单选'
				},
				{
					id:1,
					name:'多选'
				},
				{
					id:2,
					name:'判断'
				}
			],
			relationCountList:[
				{
					id:0,
					name:'0'
				},
				{
					id:1,
					name:'1'
				},
				{
					id:2,
					name:'2'
				},
				{
					id:3,
					name:'3'
				},
				{
					id:4,
					name:'4'
				},
				{
					id:5,
					name:'5次及以上'
				}
			],
			importQuestionsdialog:false,
			importQuestionsForm:{
				file:""
			},
			ExaminationQuestions:[],
			ExaminationQuestionsData:[],
			selectQuestion:[],
			inputKey:0,
			fileList2:[],
			hideProduction:false,
			currentProductId:'',
			questionMaintenanceDialog:false,
			CurrentRowData:null,
			fileData:null
		}
	},
	methods: {
		handleClick2(val){
			if(val.name == "1"){
				if(this.activeName === 'first'){
					this.clickRelatedHeadline(this.needData,0)
				}else{
					this.clickRelatedHeadline(this.needData2,0)
				}
			}
			if(val.name =="2" ){
				if(this.activeName === 'first'){
					this.clickRelatedProductFileInvestigationCount(this.needData,0)
				}else{
					this.clickRelatedProductFileInvestigationCount(this.needData2,0)
				}
			}
			if(val.name =="3" ){
				if(this.activeName === 'first'){
					this.clickRelatedProductFileJudgementCount(this.needData,0)
				}else{
					this.clickRelatedProductFileJudgementCount(this.needData2,0)
				}
				
			}
			if(val.name=="4"){
				if(this.activeName === 'first'){
					this.clickRelatedProductFileOtherCount(this.needData,0)
				}else{
					this.clickRelatedProductFileOtherCount(this.needData2,0)
				}
				
			}
			if(val.name=="5"){
				this.pages4.pageIndex = 1;
				this.pages4.pageSize = 20;
				this.queryquestionsList3()
			}
			if(val.name=="6"){
				if(this.activeName === 'first'){
					this.clickRelatedProductFileTotalPrice(this.needData,0)
				}else{
					this.clickRelatedProductFileTotalPrice2(this.needData2,0)
				}
			}
		},
		changeCategory(value){
			this.selsetCategory = value;
			this.uploadDataFile.fileCategory = value;
			this.fileList = this.fileList2.filter(data => data.fileCategory == this.selsetCategory).filter(data => data.authorId == this.addForm.authorId)
			this.tableData1 = this.tableData2.filter(data => data.fileCategory == this.selsetCategory).filter(data => data.authorId == this.addForm.authorId)
			
		},
		changeCategory2(value){
			console.log('走这里了')
			this.selsetCategory = value;
			this.uploadDataFile.fileCategory = value;
			if(this.needData.category !==value){
				this.fileList = []
			}else{
				const fileMain = this.needData.productFile.filter(item=>item.parentId==0);
				console.log('fileMain',fileMain)
				this.fileList = fileMain.map(item => ({
					name: item.fileName,   
					url: item.fileUrl,     
					uid: item.id       
				}));
			}
		},
	
		
		changeAuthor(value) {
			this.uploadDataFile.authorId = value;
			this.fileList = this.fileList2.filter(data => data.fileCategory == this.selsetCategory).filter(data => data.authorId == this.addForm.authorId)
			this.tableData1 = this.tableData2.filter(data => data.fileCategory == this.selsetCategory).filter(data => data.authorId == this.addForm.authorId)
		},	
		//合集设计价格提交
		async collectionTotalPriceConfirm(){
			let params = {
				id:this.needData.id,//
				isHot:this.productPriceList.isHot,//
				discountPercentage:this.productPriceList.discountPercentage,//折扣比例
				compilationsPrice:this.productPriceList.compilationsPrice,//折扣后价格
				isFree:this.productPriceList.isFree,//
			}
			const res = await updateProductCompilationsData(params);
			if (res.data.success){
				this.$message({
					message: res.data.message,
					type: 'success'
				});
				this.collectionDialog.totalPrice = false;
				this.getDataList()
			}else {
				this.$message({
					message: res.data.message,
					type: 'error'
				});
			}
		},
		//折扣
		changeDiscount(e){
			this.productPriceList.compilationsPrice = (Math.round(e * this.productPriceList.totalPrice) / 100).toFixed(2)
		},
		//确认发布
		async publishConfirm(){
			if (this.activeName === 'first'){
				let params = {
					productId:this.needData.id,
					status:1//1发布、3已下架
				}
				const res = await updateProductStatus(params);
				if (res.data.success){
					this.$message({
						message: res.data.message,
						type: 'success'
					});
					this.publishDialog = false;
					this.getDataList()
				}else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
			}else{
				let params = {
					productCompilationsId :this.needData.id,
					status:1//1发布、3已下架
				}
				const res = await updateProductCompilationsStatus(params);
				if (res.data.success){
					this.$message({
						message: res.data.message,
						type: 'success'
					});
					this.publishDialog = false;
					this.getDataList()
				}else{
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
			}
		},
		//发布/维护
		 async publish(){
			if(!this.needData){
				this.$message({
						message: '请选择产品',
						type: 'error'
				});
				return;
			}
			// 未发布和已下架和维护中走发布
			if(this.needData.status == 0 ||this.needData.status == 3 || this.needData.status == 4){
				this.publishDialog = true;
			}
			//已发布状态的话走维护中
			else if(this.needData.status == 1 ){
				if(this.activeName === 'first'){
					let params = {
						productId:this.needData.id,
						status:4//1发布、3已下架 4维护中
					}
					const res = await updateProductStatus(params);
					if (res.data.success){
					this.$message({
						message: res.data.message,
						type: 'success'
					});
					this.publishDialog = false;
					this.getDataList()
				}else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
					}
				}else{
					let params = {
					productCompilationsId :this.needData.id,
					status:4//1发布、3已下架 4维护中
				}
				const res = await updateProductCompilationsStatus(params);
				if (res.data.success){
					this.$message({
						message: res.data.message,
						type: 'success'
					});
					this.publishDialog = false;
					this.getDataList()
				}else{
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				}
			}
		},
		//置顶
		async topFile(){
			if (this.needData&&this.needData.id){
				this.topDialog = true;
			}else {
				this.$message({
					message: '请选择产品',
					type: 'error'
				});
			}
		},
		//确认置顶
		async topConfirm(){
			if(this.activeName === 'first'){
				let params = {
					productId:this.needData.id,
					isTop:true,
				}
				const res = await updateProductIdTop(params);
				if (res.data.success){
					this.$message({
						message: res.data.message,
						type: 'success'
					});
					this.topDialog = false;
					this.getDataList()
				}
			}else{
				let params = {
					productCompilationsId :this.needData.id,
					isTop:true,
				}
				const res = await updateProductCompilationsTop(params);
				if (res.data.success){
					this.$message({
						message: res.data.message,
						type: 'success'
					});
					this.topDialog = false;
					this.getDataList()
				}
			}
		},
		//取消置顶
		async topCancle(){
			if(this.activeName === 'first'){
				let params = {
					productId:this.needData.id,
					isTop:false,
				}
				const res = await updateProductIdTop(params);
				if (res.data.success){
					this.$message({
						message: res.data.message,
						type: 'success'
					});
					this.topDialog = false;
					this.getDataList()
				}
			}else{
				let params = {
					productCompilationsId :this.needData.id,
					isTop:false,
				}
				const res = await updateProductCompilationsTop(params);
				if (res.data.success){
					this.$message({
						message: res.data.message,
						type: 'success'
					});
					this.topDialog = false;
					this.getDataList()
				}
			}
		},
		offShelves(){
			if(!this.needData){
				this.$message({
						message: '请选择下架的产品',
						type: 'error'
				});
				return;
			}
			if (this.needData&&this.needData.id){
				if (this.needData.status===0) {
					this.$message({
						message: '请确认该产品是否已发布',
						type: 'error'
					});
					return;
				}this.$confirm('确认下架该产品吗?', '提示', {
					type: 'warning'
				}).then(async () => {
					if (this.activeName === 'first'){
						let params = {
							productId:this.needData.id,
							status:3//1发布、3已下架
						}
						const res = await updateProductStatus(params);
						if (res.data.success){
							this.$message({
								message: res.data.message,
								type: 'success'
							});
							this.getDataList()
						}
					}else{
						let params = {
							productCompilationsId :this.needData.id,
							status:3//1发布、3已下架
						}
						const res = await updateProductCompilationsStatus(params);
						if (res.data.success){
							this.$message({
								message: res.data.message,
								type: 'success'
							});
							this.topDialog = false;
							this.getDataList()
						}
					}
				}).catch(() => {

				});
			}
		},
		changePrice(){
			let totalWatchPrice = 0;
			let totalDownloadPrice = 0;
			for (let i = 0; i < this.productPriceList.productFile.length; i++) {
				const item = this.productPriceList.productFile[i];
				totalDownloadPrice += parseFloat(item.fileDownloadPrice) || 0;
			}
			this.$set(this.productPriceList, 'totalPrice', totalDownloadPrice);
		},
		productFileTotalPriceConfirm(){
			let paramse = {
				id:this.productPriceList.id,
				isHot:this.productPriceList.isHot,
				isFree:this.productPriceList.isFree,
				productFilePrice:this.productPriceList.productFile.map(item => ({
					id:item.id,
					fileDownloadPrice:item.fileDownloadPrice,
					fileWatchPrice:item.fileWatchPrice,
				})),
			}
			updateProductFilePrice(paramse).then(res => {
				if (res.data.success){
					this.$message({
						message: res.data.message,
						type: 'success'
					});
					this.relatedDialog.productFileTotalPrice = false
					this.getDataList()
				}else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
			})
		},
		confirmList() {
			this.relatedTableData =[...this.relatedTableData, ...this.multipleSelection]
			this.relatedDialogList = false
		},
		closeDialog() {
			this.relatedDialog.productFileInvestigationCount = false;
		},
		//获取后期作者列表数据
		async userInfoList(){
			let params = {}
			const res = await getUserInfoList(params)
			if (res.data.success){
				this.authorIdList = res.data.response
			}
		},

		async clickCollectionName(val){
			let params = {
				productIdList:val.productsIdList.join(',') ,
			}
			const res = await getProductIdListData(params)
			if (res.data.success){
				this.collectionNameDialogData = res.data.response
			}
			this.collectionDialog.compilationsHeadline = true;
		},
		//点击单品列表名称
		async clickRelatedHeadline(val,mark){
			// 1. 先重置标签页
    		this.activetagIndex = '1';
			this.addForm={
				verticalImageUrl:'',//产品首图竖
				provinceId:undefined,//省
				cityId:undefined,//市
				id:undefined,
				code:undefined,//编号
				headline:undefined,//产品标题
				category:undefined,//产品形式（主体文件格式：1视频、2word、3ppt）
				productTypeId:undefined,//产品分类id（数据字典id）
				disasterGrade	:undefined,//严重程度（0一般、1较大、2重大、3特大）
				disasterTime:undefined,//火灾日期
				casualtiesCount:undefined,//伤亡人数
				productTagId:[],//产品标签
				authorId:undefined,//原始作者用户Id（单）
				mastermindId:undefined,//策划Id（单）
				anaphaseId:undefined,//后期Id（多）
				productFileId:undefined,//主体文件Id
				isFree:undefined,//是否免费
				isTop:undefined,//是否置顶
				isHot:undefined,//是否热门
				productIntroduce:undefined,//产品简介
				firstImageUrl:'',//产品首图
				status:undefined,//发布状态：0未发布、1已发布、3已下架
				issuerId:undefined,//发布人id
				compilationsCoverImage:'',//产品合集封面图片
				compilationsHeadline:undefined,//产品名称
				compilationsCode:undefined,//产品合集编号
				productsIdList:[],//产品合集产品IdList
				fileUrl:'',
				isPerfect:undefined,
			}
			let params = {
				productIdList:val.id.toString(),
			}
			const res = await getProductIdListData(params)
			if(res.data.success&&res.data.response.length>0){
				this.addForm = res.data.response[0];
				// 关键：接口返回的对象顶层没有 fileUrl 字段，需要用 $set 把它变成响应式属性，
				// 否则后续 this.addForm.fileUrl = xxx 的赋值不会触发 watch
				this.$set(this.addForm, 'fileUrl', '');
				this.addForm.anaphaseId = res.data.response[0].anaphaseId.split(',').map(Number);
				this.addForm.productTagId = res.data.response[0].productTagId.split(',').map(Number);
				await this.getCityPage({pid:0},0);
				await this.getCityPage({pid:res.data.response[0].provinceId},1);
				this.tableData1 = [];
				this.fileList=[]
				const fileMain = this.addForm.productFile.filter(item=>item.parentId==0);
				this.selsetCategory = fileMain[0].fileCategory		
				if(fileMain[0].fileCategory==1){
					this.parentId = fileMain[0].parentId
					this.tableData1 = fileMain.map(item=>({
					fileName:item.fileName,
					size:item.fileSize,
					progress:100
					}))
				}else{
					this.fileList = fileMain.map(item => ({
						name: item.fileName,   
						url: item.fileUrl,     
						uid: item.id   
					}));
				}																				
			}
			if(mark==1){
				this.relatedDialog.productFileCount = true
			}else{		
				this.relatedDialog.headline = true
			}
		},
		
		//点击单品列表调查报告
		async clickRelatedProductFileInvestigationCount(value,mark){
			this.fileData = null
			this.addForm.fileUrl = ''
			this.needData = value;
			this.currentProductId = value.productFileId;
			if (value&&value.status ===1&&mark!=0 ){
				this.$message.error('产品已上架，请下架之后更改！')
				return
			}
			this.clearFileInput()
			this.$nextTick(() => {
				this.inputKey++; 
				console.log('Input Key 已强制更新，Input 已重置');
			});
			this.addForm = {
				productTypeSecondId:undefined,//产品分类二级id（数据字典id）
				verticalImageUrl:'',//产品首图竖
				provinceId:undefined,//省
				cityId:undefined,//市
				id:undefined,
				code:undefined,//编号
				headline:undefined,//产品标题
				category:1,//产品形式（主体文件格式：1视频、2word、3ppt）
				productTypeId:undefined,//产品分类id（数据字典id）
				disasterGrade:undefined,//严重程度（0一般、1较大、2重大、3特大）
				disasterTime:undefined,//火灾日期
				casualtiesCount:undefined,//伤亡人数
				productTagId:[],//产品标签
				authorId:undefined,//原始作者用户Id（单）
				mastermindId:undefined,//策划Id（单）
				anaphaseId:undefined,//后期Id（多）
				productFileId:undefined,//主体文件Id
				isFree:undefined,//是否免费
				isTop:undefined,//是否置顶
				isHot:undefined,//是否热门
				productIntroduce:undefined,//产品简介
				firstImageUrl:'',//产品首图
				status:undefined,//发布状态：0未发布、1已发布、3已下架
				issuerId:undefined,//发布人id
				compilationsCoverImage:'',//产品合集封面图片
				compilationsHeadline:undefined,//产品名称
				compilationsCode:undefined,//产品合集编号
				productsIdList:[],//产品合集产品IdList,
				fileUrl:'',
				isPerfect:undefined,
			}
			// this.addForm.category = value.category
			this.addForm.authorId = value.authorId
			this.addForm.headline = value.headline
			this.selsetCategory = 1
			this.fileList = []
			this.uploadDataFile ={
				parentId:value.productFileId,
				fileCategory:this.selsetCategory,
				fileAttribute:1,
				authorId:value.authorId,
			}	
			this.tableData1 = []
			this.parentId = value.productFileId		
			this.fileAttribute = 1;
			this.fileCategory = 1;
			await this.getProductFileList(value.productFileId,1)
			if(mark==0){
				this.relatedDialog.productFileInvestigationCount= false;
			}else{
				this.relatedDialog.productFileInvestigationCount= true;
			}
		},
		//点击单品列表判决书
		async clickRelatedProductFileJudgementCount(value,mark){
			this.fileData = null
			this.addForm.fileUrl = ''
			this.needData = value;
			this.currentProductId = value.productFileId;
			if (value&&value.status ===1&&mark!=0 ){
				this.$message.error('产品已上架，请下架之后更改！')
				return
			}
			
			this.clearFileInput()
			this.$nextTick(() => {
				this.inputKey++; 
				console.log('Input Key 已强制更新，Input 已重置');
			});
			this.addForm = {
				productTypeSecondId:undefined,//产品分类二级id（数据字典id）
				verticalImageUrl:'',//产品首图竖
				provinceId:undefined,//省
				cityId:undefined,//市
				id:undefined,
				code:undefined,//编号
				headline:undefined,//产品标题
				category:1,//产品形式（主体文件格式：1视频、2word、3ppt）
				productTypeId:undefined,//产品分类id（数据字典id）
				disasterGrade	:undefined,//严重程度（0一般、1较大、2重大、3特大）
				disasterTime:undefined,//火灾日期
				casualtiesCount:undefined,//伤亡人数
				productTagId:[],//产品标签
				authorId:undefined,//原始作者用户Id（单）
				mastermindId:undefined,//策划Id（单）
				anaphaseId:undefined,//后期Id（多）
				productFileId:undefined,//主体文件Id
				isFree:undefined,//是否免费
				isTop:undefined,//是否置顶
				isHot:undefined,//是否热门
				productIntroduce:undefined,//产品简介
				firstImageUrl:'',//产品首图
				status:undefined,//发布状态：0未发布、1已发布、3已下架
				issuerId:undefined,//发布人id
				compilationsCoverImage:'',//产品合集封面图片
				compilationsHeadline:undefined,//产品名称
				compilationsCode:undefined,//产品合集编号
				productsIdList:[],//产品合集产品IdList,
				fileUrl:'',
				isPerfect:undefined,
			}
			// this.addForm.category = value.category
			this.addForm.authorId = value.authorId
			// this.selsetCategory = value.category
			this.selsetCategory = 1
			this.fileList = []
			this.uploadDataFile ={
				parentId:value.productFileId,
				fileCategory:this.selsetCategory,
				fileAttribute:2,
				authorId:value.authorId,
			}
			this.tableData1 = []
			this.parentId = value.productFileId
			this.addForm.headline = value.headline
			this.fileAttribute = 2;
			this.fileCategory = 1;
			await this.getProductFileList(value.productFileId,2)
			if(mark==0){
			this.relatedDialog.productFileJudgementCount = false;
			}else{
			this.relatedDialog.productFileJudgementCount = true;
			}
		},
		//点击单品列表其它文档
		async clickRelatedProductFileOtherCount(value,mark){
			this.fileData = null
			this.addForm.fileUrl = ''
			this.needData = value;
			this.currentProductId = value.productFileId;
			if (value&&value.status ===1&&mark!=0 ){
				this.$message.error('产品已上架，请下架之后更改！')
				return
			}
		 	this.clearFileInput()
			this.$nextTick(() => {
				this.inputKey++; 
				console.log('Input Key 已强制更新，Input 已重置');
			});
			this.addForm = {
				productTypeSecondId:undefined,//产品分类二级id（数据字典id）
				verticalImageUrl:'',//产品首图竖
				provinceId:undefined,//省
				cityId:undefined,//市
				id:undefined,
				code:undefined,//编号
				headline:undefined,//产品标题
				category:1,//产品形式（主体文件格式：1视频、2word、3ppt）
				productTypeId:undefined,//产品分类id（数据字典id）
				disasterGrade	:undefined,//严重程度（0一般、1较大、2重大、3特大）
				disasterTime:undefined,//火灾日期
				casualtiesCount:undefined,//伤亡人数
				productTagId:[],//产品标签
				authorId:undefined,//原始作者用户Id（单）
				mastermindId:undefined,//策划Id（单）
				anaphaseId:undefined,//后期Id（多）
				productFileId:undefined,//主体文件Id
				isFree:undefined,//是否免费
				isTop:undefined,//是否置顶
				isHot:undefined,//是否热门
				productIntroduce:undefined,//产品简介
				firstImageUrl:'',//产品首图
				status:undefined,//发布状态：0未发布、1已发布、3已下架
				issuerId:undefined,//发布人id
				compilationsCoverImage:'',//产品合集封面图片
				compilationsHeadline:undefined,//产品名称
				compilationsCode:undefined,//产品合集编号
				productsIdList:[],//产品合集产品IdList,
				fileUrl:'',
				isPerfect:undefined,
			}
			// this.addForm.category = value.category
			this.addForm.authorId = value.authorId
			// this.selsetCategory = value.category
			this.selsetCategory = 1
			this.fileList = []
			this.uploadDataFile ={
				parentId:value.productFileId,
				fileCategory:this.selsetCategory,
				fileAttribute:3,
				authorId:value.authorId,
			}
			this.tableData1 = []
			this.parentId = value.productFileId
			
			this.addForm.headline = value.headline
			this.fileAttribute = 3;
			this.fileCategory = 1;
			await this.getProductFileList(value.productFileId,3)
			if(mark==0){
				this.relatedDialog.productFileOtherCount = false;
			}else{
				this.relatedDialog.productFileOtherCount = true;
			}
			// this.relatedDialog.productFileOtherCount = true;
		},
		//点击单品列表相关资料
		async clickRelatedProductFileRelatedCount(value){
			this.tableData1 = []
			this.parentId = value.productFileId
			this.addForm.headline = value.headline
			this.addForm.authorId = value.authorId
			this.fileAttribute = undefined;
			this.fileCategory = 1;
			await this.getProductFileList(value.productFileId,undefined)
			this.relatedDialog.productFileRelatedCount = true;
		},
		//点击列表总价
		async clickRelatedProductFileTotalPrice(value,mark){
			if (value&&value.status ===1 &&mark!=0 ){
				this.$message.error('产品已上架，请下架之后更改价格！')
				return
			}
			this.productPriceList = value
			if (this.activeName === 'first'){
				let totalDownloadPrice = 0;
				
				for (let i = 0; i < value.productFile.length; i++) {
					const item = value.productFile[i];
					totalDownloadPrice += parseFloat(item.fileDownloadPrice) || 0;
				}
				
				this.$set(this.productPriceList, 'totalPrice', totalDownloadPrice);
				if(mark==0){
					this.relatedDialog.productFileTotalPrice = false;
				}else{
					this.relatedDialog.productFileTotalPrice = true;
				}
			}else if (this.activeName === 'second'){
				let params = {
						productIdList :value.productsIdList.join(','),
				}
				getProductIdListData(params)
				const res = await getProductIdListData(params)
				let array = []
				res.data.success?array = res.data.response:array = [];
				this.productPriceList.productFile = array
				let totalDownloadPrice = 0;
				for (let i = 0; i < array.length; i++) {
					const item = array[i];
					totalDownloadPrice += parseFloat(item.productFileTotalPrice) || 0;
				}
				this.$set(this.productPriceList, 'totalPrice', totalDownloadPrice);
				this.collectionDialog.totalPrice = true;
			}
			
		},
		//点击合集里的单集的产品标题
		 clickRelatedProductFileTotalPrice2(value,mark){
			if (value&&value.status ===1&&mark!=0 ){
				this.$message.error('产品已上架，请下架之后更改价格！')
				return
			}
			this.productPriceList = value
				let totalDownloadPrice = 0;
				for (let i = 0; i < value.productFile.length; i++) {
					const item = value.productFile[i];
					totalDownloadPrice += parseFloat(item.fileDownloadPrice) || 0;
				}
				this.$set(this.productPriceList, 'totalPrice', totalDownloadPrice);
				if(mark==0){
					this.relatedDialog.productFileTotalPrice = false;
				}else{
					this.relatedDialog.productFileTotalPrice = true;
				}
		},
		async getProductFileList(id,type){
			let params = {
				productFileId:id,
				fileAttribute:type,//文件属性：1调查报告、2判决书、3其它文档
			}
			const res = await getProductIdFileListAttachmentData( params)
			if(res.data.success){
				if(res.data.response.length==0){
					this.hideProduction = true
				}else{
					this.hideProduction = false
				}
				if(!type){
					this.tableData1 =  res.data.response.map(data=>({
						id: data.id,
						authorId:data.authorId,
						fileName: data.fileName,
						size: data.fileSize,
						progress: 100,
						type: data.fileAttribute===1?'调查报告':(data.fileAttribute===2?'判决书':'其它文档'),
						}))
				}else{
					this.tableData1 = res.data.response.filter(data => data.fileCategory == 1).filter(data => data.authorId == this.addForm.authorId).map(data=>({
					id: data.id,
					authorId:data.authorId,
					fileName: data.fileName,
					size: data.fileSize,
					fileCategory:data.fileCategory,
					progress: 100,
					type: data.fileAttribute===1?'调查报告':(data.fileAttribute===2?'判决书':'其它文档'),
				}))
				this.tableData2 = res.data.response.filter(data => data.fileCategory == 1).map(data=>({
					id: data.id,
					authorId:data.authorId,
					fileName: data.fileName,
					size: data.fileSize,
					fileCategory:data.fileCategory,
					progress: 100,
					type: data.fileAttribute===1?'调查报告':(data.fileAttribute===2?'判决书':'其它文档'),
				}))
				this.fileList2 = res.data.response.filter(data => data.fileCategory !== 1).map(data=>({
					id: data.id,
					authorId:data.authorId,
					name: data.fileName,
					size: data.fileSize,
					progress: 100,
					fileCategory:data.fileCategory,
					type: data.fileAttribute===1?'调查报告':(data.fileAttribute===2?'判决书':'其它文档'),
				}))
				}
				
			}
		},
		//创建合集提交
		addRelationConfirm(){
			this.$refs['addRealation'].validate(async (valid)=>{
				if(valid){
					this.addForm.productsIdList = this.relatedTableData.map(item => item.id);
					this.addForm.productsId = this.relatedTableData.map(item => item.id).join(',')
					this.addForm.relationProductsId = this.relatedTableData.map((item, index) => {
						return {
							productId: item.id, // 对应文档里的 productId (integer)
							sort: item.sortOrder || index + 1 // 对应文档里的 sort (integer)
							// 注意：如果上面拖拽逻辑里没赋值 sortOrder，这里用 index+1 兜底也是可以的
						};
					});
					let params = {
						...this.addForm
					}
					// const namelist = this.editFalse?`updateProductCompilationsData`:`addProductCompilationsData`
					if(this.editFalse){
						params.id = this.needData.id
						const res = await updateProductCompilationsData( params)
						if(res.data.success){
							this.dialogs.addCollection.dialog = false
							this.$message.success(res.data.message)
							this.getDataList()
						}else {
							this.$message.error(res.data.message)
						}
					}else {
						const res = await addProductCompilationsData( params)
						if(res.data.success){
							this.dialogs.addCollection.dialog = false
							this.$message.success(res.data.message)
							this.getDataList()
						}else {
							this.$message.error(res.data.message)
						}
					}
				}
			})
		},
		deleteRelation(val){
			this.relatedTableData = this.relatedTableData.filter(item => item.id !== val.id)
		},
		handleSelectionChange(val) {
			this.multipleSelection = val;
		},
		//关联单品
		async relatedItems(){
			let params = {
				status:1,
				category:this.addForm.category,
				productsExistIdList:this.relatedTableData&&this.relatedTableData.length>0?this.relatedTableData.map(item => item.id).join(','):undefined,
				pageIndex:this.pages2.pageIndex,
				pageSize:this.pages2.pageSize,
			}
			const res = await getProductList( params)
			if(res.data.success){
				this.relatedSelectionTableData = res.data.response.data
				this.pages2.dataCount = res.data.response.dataCount

			}
			this.relatedDialogList = true
		},
		handleClick(value) {
			this.filters = {
				headlineOrCode:undefined,//标题或者编号
				category:undefined,//产品形式（主体文件格式：1视频、2word、3ppt）
				productTypeId:undefined,//产品分类
				status:undefined,//发布状态：0未发布、1已发布、3已下架
				releaseTime:undefined,//发布日期
			}
			this.getDataList()
		},
		// 图片上传之前函数
		beforeUpload(file) {
			const isLt2M = file.size / 1024 / 1024 > 5;
			var type = file.name.substring(file.name.lastIndexOf(".")+1);
			if (type == 'jpg' || type == 'png') {} else {
				this.$message.error('上传图片只能是 JPG/PNG 格式!');
				return false;
			}
			if (!isLt2M === false) {
				this.$message.error('上传图片大小不能超过 5MB!');
				return false
			}
		},
		beforeUpload_file(file) {
			if(!this.addForm.authorId){
				this.$message.warning('请先选择原始作者')
				return false;
			}
			 const formatMap = {
				'word': ['.doc', '.docx'],
				'ppt': ['.ppt', '.pptx'],
				'pdf': ['.pdf']
			};
					if(this.selsetCategory==2){
						var allowedExts = formatMap.word;
					}else if(this.selsetCategory==3){
						var allowedExts = formatMap.ppt;
					}else if(this.selsetCategory==4){
						var allowedExts = formatMap.pdf;
					}
					
					const fileName = file.name;
					const fileExt = fileName.substring(fileName.lastIndexOf('.')).toLowerCase(); // 获取 .xxx 并转小写
					const isAllowed = allowedExts.includes(fileExt);
					if (!isAllowed) {
					this.$message.error(`当前选择的是【${fileExt}】格式，请上传对应的 ${allowedExts.join('/')} 文件！`);
						return false; // 拦截上传
					}
		},
		
		handle_success_file(res,file,fileList) {
			this.fileList = fileList
			if(res.success) {
				this.$message.success('上传成功')
				this.addForm.fileUrl = res.response.webupurl
				this.addForm.productFileId = res.response.productFileId;
				if(this.fileAttribute==1){ 
					console.log('获取调查报告的文件')
					this.getProductFileList(this.currentProductId,1)
				}else if(this.fileAttribute==2){
					console.log('获取判决书的文件')
					this.getProductFileList(this.currentProductId,2)
				}else if(this.fileAttribute==3){
					console.log('获取相关资料的文件')
					this.getProductFileList(this.currentProductId,3)
				}
				this.getListData()
			}else{
				this.$message.error(res.message)
			}
		},
		handle_success_file2(res,file,fileList) {
			this.fileList = fileList
			if(res.success) {
				this.$message.success('上传成功')
				this.addForm.fileUrl = res.response.webupurl
				this.addForm.productFileId = res.response.productFileId;
			}else{
				this.$message.error(res.message)
			}
		},
	
		
		// 图片上传成功时的函数
		handle_success(res,file) {
			if(res.success) {
				this.$message.success('图片上传成功')
				this.addForm.firstImageUrl = res.response.weburl
				this.addForm.compilationsCoverImage = res.response.weburl
			}else{
				this.$message.error(res.Message)
			}
		},
		// 图片上传成功时的函数
		handle_success2(res,file) {
			if(res.success) {
				this.$message.success('图片上传成功')				
				this.addForm.verticalImageUrl = res.response.weburl
			}else{
				this.$message.error(res.Message)
			}
		},
		beforeRemove(file,fileList){
					console.log('file',file)
					let params = {
						productFileId:file.id,
					}
					deleteProductFileIdAttachment(params).then(res => {
						if (res.data.success){
							this.$message({
								message: "删除成功！",
								type: "success"
							});
							this.getListData()
							
						}
					})
		},
		selectRowChangeSheng(value){
			this.getCityPage({pid:value},1);
		},
		async selectRowChangeProduct(value){
			let params = {
				dataType:0,//数据类型:0:产品分类 1：产品标签
				parentId:value,//父级Id
			}
			const res = await  getByDataCode(params)
			if (res.data.success) {
				this.productTypeIdChildList= res.data.response
			}
		},
		closePreview(){
			// 清空 #player 所在的 div
			const playerDiv = document.querySelector("#player");
			const preViewDiv = document.querySelector("#preview");
			if (playerDiv) {
				playerDiv.innerHTML = '';
			}
			if (preViewDiv){
				preViewDiv.innerHTML = '';
			}
			this.onPause()
			this.dialogs.addType.firurl = false
		},
		start(uploaderid) {// 单个上传
			//console.log('this.addForm.fileUrl',this.addForm.fileUrl)
			// if(this.addForm.fileUrl==null){
			// 	this.$message.warning('请稍等视频上传服务器后在点击开始!')
			// 	return
			// };
			this.videoUpload.resumeFile(uploaderid);
		},
		stop(uploaderid) {// 单个暂停
			this.videoUpload.stopFile(uploaderid);
		},
		remove(uploaderid) {// 单个删除
			this.fileData = null
			this.addForm.fileUrl = ''	
			this.videoUpload.removeFile(uploaderid);
			if (this.parentId||this.parentId===0){
				this.$confirm('确认删除该视频吗?', '提示', {
					type: 'warning'
				}).then(() => {
					let params = {
						productFileId:uploaderid,
					}
					deleteProductFileIdAttachment(params).then(res => {
						if (res.data.success){
							this.$message({
								message: "删除成功！",
								type: "success"
							});
							this.getListData()
						if (this.fileAttribute === 1){
							this.getProductFileList(this.currentProductId,1)
						}else if (this.fileAttribute === 2){				
							this.getProductFileList(this.currentProductId,2)						
						}else if (this.fileAttribute === 3){			
							this.getProductFileList(this.currentProductId,3)																											
						}
						}
					})
					this.tableData1 = this.tableData1.filter((item) => item.id !== uploaderid)
				})
			}else{
				this.tableData1 = this.tableData1.filter((item) => item.id !== uploaderid)
			}
			
		},
		async doUpload(e) {
			this.getUserData();
			// 获取文件输入DOM
			// const inputDOM = this.$refs.inputer;
			// const files = inputDOM.files;
			const files = e.target.files;
			if(this.tableData1.length>=1 && !this.parentId){
				this.$message({
					message:"主体视频只能添加一条！",
			 		type:'warning'
				})
				return;
			}

			 const fileListArray = Array.from(files);
			 const duplicateFile = fileListArray.find(file =>this.tableData1.some(item => item.fileName === file.name));
			 if (duplicateFile) {
				this.$message.warning(`文件 "${duplicateFile.name}" 已存在`);
				return;
    		}
			// 使用 for...of 循环替代 forEach，支持 async/await
			for (const file of files) {
				try {
					// 文件上传相关配置
					const fileSetting = {
						title: file.name,
						desc: 'jssdk插件上传',
						cataid: this.fileSetting.cataid,
						tag: '',
						luping: 0,
						keepsource: 0,
						state: ''
					};
					
					// 创建FormData（直接作为请求体）
					const formData = new FormData();
					formData.append('file', file); // 添加文件
					
					// 如果后端需要其他参数，直接添加到FormData中
					Object.entries(fileSetting).forEach(([key, value]) => {
						formData.append(key, value);
					});
					
					
					// 调用上传插件（如果需要）
					let uploadManager = this.videoUpload.addFile(
							file,
							{
								FileStarted: this.onFileStarted,
								FileProgress: this.onFileProgress,
								FileSucceed: this.onFileSucceed,
								FileFailed: this.onFileFailed,
								FileStopped: this.onFileStopped,
							},
							fileSetting
					);
										
					this.addTableData(uploadManager);
					// 调用后端接口（直接传递FormData）
					const res = await uploadProductDownloadFile(formData);
			
					if (res.data.success) {
						// this.$message.success('文件上传成功', { duration: 3000 });
						this.addForm.fileUrl = res.data.response.weburl;
						this.$message.success(res.data.message)
						// this.getUserData();
					} else {
						this.$message.error(res.data.message || '上传失败', { duration: 3000 });
					}												
				} catch (error) {
					console.log('文件上传出错:', error);
					this.$message.error('上传过程中发生错误，请重试', { duration: 3000 });
				}
			}
			
		},
		onFileStarted(data) {
			this.tableData1.filter((item) => item.id === data.uploaderid)[0].progress = 0
		},
		onFileProgress(data) {
			let p = parseInt(data.progress * 100);// 上传的进度条
			this.tableData1.filter((item) => item.id === data.uploaderid)[0].progress = p
			
		},
		onFileSucceed(data) {
			console.log("文件上传成功: ", data.fileData.filename);
			console.log('this.tableData1',this.tableData1)
			this.tableData1.filter((item) => item.fileName === data.fileData.filename)[0].progress = 100
			this.fileUpload = {
				// videoName:data.fileData.fileData,
				VideoSize:data.fileData.size,
				VideoCode:data.fileData.vid,
			}
			// this.addForm.productFileId = 2
			this.fileData = data.fileData
				
		},
		addFileByCodeFun(){
				let params = {
					parentId:this.parentId?this.parentId:0,
					fileName:this.fileData.filename,
					fileSize:this.fileData.filesize,
					fileCategory:this.fileCategory?this.fileCategory:1,
					fileAttribute:this.fileAttribute?this.fileAttribute:0,
					fileCode:this.fileData.vid,
					firstImageUrl:this.addForm.firstImageUrl,
					authorId:this.addForm.authorId,
					fileUrl:this.addForm.fileUrl,
				}
				addFileByCode(params).then(res => {
					if(res.data.success){
						
						if (this.editFalse){
							this.addForm.productFileId = res.data.response
						}else {
							this.addForm.productFileId = res.data.response
						}
						if (this.fileAttribute === 1){
							this.getListData()
							this.getProductFileList(this.currentProductId,1)
							this.relatedDialog.productFileInvestigationCount = false
						}else if (this.fileAttribute === 2){
							this.getListData()
							this.getProductFileList(this.currentProductId,2)
							this.relatedDialog.productFileJudgementCount = false
						}else if (this.fileAttribute === 3){
							this.getListData()
							this.getProductFileList(this.currentProductId,3)
							this.relatedDialog.productFileOtherCount = false
						}
						
					}
				})
		},
		
		onFileFailed(data) {
			console.log("文件上传失败: ", data);
		},
		onFileStopped(data) {
			console.log("文件上传停止: ", data);
		},
		addTableData(data) { // 增加表格数据
			console.log('data',data)
			let obj = {
				id: data.id,
				fileName: data.fileData.title,
				fileSize: data.fileData.size,
				progress: 0,
			}
			if ((this.tableData1&&this.tableData1.length<1)||this.parentId){
					this.tableData1.push(obj)
			}
			else {
				this.$message({
					message:"主体视频只能添加一条！",
			 		type:'warning'
				})
			}
		},

		getUserData() { // 获取用户详细信息
			let params = {}
			getVideoUploadParams(params).then(res=>{
				if (res.data.success){
					const hash = res.data.response.hash
					const sign = res.data.response.sign
					const userid = (res.data.response.userId)
					const ptime = parseInt(res.data.response.ts)
					let userData = {
						userid: userid,
						ptime: ptime,
						sign: sign,
						hash: hash
					};
					this.videoUpload.updateUserData(userData);
					
				}
			})
		},
		transformSize(bytes) {// 文件大小转换
			const bt = parseInt(bytes);
			let result;
			if (bt === 0) {
				result = '0B';
			} else {
				const k = 1024;
				const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
				const i = Math.floor(Math.log(bt) / Math.log(k));
				if (typeof i !== 'number') {
					result = '-';
				} else {
					result = (bt / Math.pow(k, i)).toFixed(2) + sizes[i];
				}
			}
			return result;
		},
		clearFileInput() {
			console.log('走clearFileInput了')
			// 先判断 ref 对应的 DOM 元素是否存在，避免报错
			if (this.$refs.inputer) {
				// 清空文件值（原生 DOM 操作）
				this.$refs.inputer.value = '';
			}
		},

		handleAdd(){
			this.clearFileInput()
			this.$nextTick(() => {
				this.inputKey++; 
				console.log('Input Key 已强制更新，Input 已重置');
			});
			this.fileAttribute = 0;
			this.selsetCategory = 1;
			this.parentId = undefined
			this.editFalse = false;
			this.tableData1 = []
			this.fileList = []
			// this.getUserData()
			this.getCityPage({pid:0},0);
			this.previewBlooean = false;
			this.addForm={
				verticalImageUrl:'',//产品首图竖
				provinceId:undefined,//省
				cityId:undefined,//市
				id:undefined,
				code:undefined,//编号
				headline:undefined,//产品标题
				category:1,//产品形式（主体文件格式：1视频、2word、3ppt）
				productTypeId:undefined,//产品分类id（数据字典id）
				disasterGrade	:undefined,//严重程度（0一般、1较大、2重大、3特大）
				disasterTime:undefined,//火灾日期
				casualtiesCount:undefined,//伤亡人数
				productTagId:[],//产品标签
				authorId:undefined,//原始作者用户Id（单）
				mastermindId:undefined,//策划Id（单）
				anaphaseId:undefined,//后期Id（多）
				productFileId:undefined,//主体文件Id
				isFree:undefined,//是否免费
				isTop:undefined,//是否置顶
				isHot:undefined,//是否热门
				productIntroduce:undefined,//产品简介
				firstImageUrl:'',//产品首图
				status:undefined,//发布状态：0未发布、1已发布、3已下架
				issuerId:undefined,//发布人id
				compilationsCoverImage:'',//产品合集封面图片
				compilationsHeadline:undefined,//产品名称
				compilationsCode:undefined,//产品合集编号
				productsIdList:[],//产品合集产品IdList
				isPerfect:undefined,
				fileUrl:'',
			}
			this.fileData = null
	

			
			if (this.activeName === 'first'){
				if (this.$refs.Form) {
          			this.$refs.Form.resetFields();
        		}
				this.dialogs.addType.dialog = true;
			}else if (this.activeName === 'second'){
				if (this.$refs.addRealation) {
          			this.$refs.addRealation.resetFields();
        		}
				this.relatedSelectionTableData = []
				this.relatedTableData = []
				this.dialogs.addCollection.dialog = true;
				this.$nextTick(() => {
					this.initSortable();
				});
			}
		},
		//获取视频标签列表
		getVideoLabelList(){
			let params = {
 				projectId:window.localStorage.getItem('projectId')
			}
		},
		
		callFunction(item) {
			this[item.func].apply(this, item);
		},
		getDataList(){
			this.pages.pageIndex = 1; 
  			this.pages.pageSize = 20; 
			this.getListData()
		},
		// 列表查询接口
		async getListData(){
			this.listLoading = true
			if (this.activeName === 'first'){
				let params = {
					pageIndex: this.pages.pageIndex,
					pageSize: this.pages.pageSize,
					...this.filters,
				}
				getProductListPage(params).then(res => {
					let result = res.data
					if(result.success) {
						this.tableData = result.response.data
						this.pages.dataCount = result.response.dataCount
					}
					this.listLoading = false
				})
			}else if (this.activeName === 'second'){
				let params = {
					pageIndex: this.pages1.pageIndex,
					pageSize: this.pages1.pageSize,
					...this.filters,
				}
				getProductCompilationsListPage(params).then(res => {
					let result = res.data
					if(result.success) {				
						this.tableData3= result.response.data
						this.pages1.dataCount = result.response.dataCount
					}
					this.listLoading = false
				})
			}
		},
		//预览
		preview(row){
			this.needDataPhoto = row;
			if (row.productFile[0].playSafeCode === null){
				this.$message({
					message:'视频正在审核中，请稍后再试！',
					type:'warning'
				})
				return;
			}
			this.loadPlayerScript(this.loadPlayer);
			if (this.player) {
			}
			this.dialogs.addType.firurl = true;
		},
		async addConfirm(){
			  this.$refs.Form.validate((valid) => {
				if (valid) {
					this.$confirm("确认提交吗？", "提示", {}).then(() => {
			// this.addForm.productFileId = 2
			let params = {
				...this.addForm,
				...this.fileUpload,
			}
			this.listLoading = true
			setTimeout(()=>{
				if (this.editFalse){
					updateProductData(params).then(res=>{
						if (res.data.success){
							this.getDataList()
							this.dialogs.addType.dialog = false ;
							this.$message({
								message:res.data.message,
								type:'success'
							})
							this.$refs.inputer.value = '';
						}else{
							this.$message({
								message:res.data.message,
								type:'warning'
							})
						}
						this.listLoading = false
					})
				}else {
					addProductData(params).then(res=>{
						if (res.data.success){
							this.getDataList()
							this.dialogs.addType.dialog = false ;
							this.$message({
								message:res.data.message,
								type:'success'
							})
							this.$refs.inputer.value = '';
						}else{
							this.$message({
								message:res.data.message,
								type:'warning'
							})
						}
						this.listLoading = false
					})
				}
			},2000)
					})
				}
			  })
		},
		
		loadPlayerScript(callback) {			
			if (!window.polyvPlayer) {
				const myScript = document.createElement("script");
				myScript.setAttribute("src", this.vodPlayerJs);
				myScript.onload = callback;
				document.body.appendChild(myScript);
			} else {
				callback();
			}
		},
		// 暂停事件
		onPause() {
			let that=this;
			this.player.on("s2j_onVideoPause", function (e) {
				that.flag=true;
			});
		},

		loadPlayer() {
			// 清空 #player 所在的 div
			const playerDiv = document.querySelector("#player");
			const preViewDiv = document.querySelector("#preview");
			if (playerDiv) {
				playerDiv.innerHTML = '';
			}
			if (preViewDiv){
				preViewDiv.innerHTML = '';
			}
			const polyvPlayer = window.polyvPlayer;
			
			this.player = polyvPlayer({
				wrap: this.previewBlooean?'#preview':"#player" ,
				width: "100%",
				height: "544",
				vid: this.needDataPhoto.productFile[0].fileCode,
				autoplay: false,
				// ban_preview_video: "on",
				// allowFullscreen:false,
				code:'off',
				playsafe:this.needDataPhoto.productFile[0].playSafeCode,
			});
			this.previewBlooean = false ;
		},
		
		async handleEdit(){
			if (!this.needData){
				this.$message({
					message:'请选择一条数据',
					type:'warning'
				})
				return;
			}
			if (this.needData.status === 1){
				this.$message({
					message:'产品已上架，请先改为维护中!',
					type:'warning'
				})
				return;
			}
			this.clearFileInput()
			this.$nextTick(() => {
				this.inputKey++; 
				console.log('Input Key 已强制更新，Input 已重置');
			});
			this.fileAttribute = 0;
			this.getCityPage({pid:0},0);
			this.getCityPage({pid:this.needData.provinceId},1);
			this.addForm={
				verticalImageUrl:'',//产品首图
				provinceId:undefined,//省
				cityId:undefined,//市
				id:undefined,
				code:undefined,//编号
				headline:undefined,//产品标题
				category:undefined,//产品形式（主体文件格式：1视频、2word、3ppt）
				productTypeId:undefined,//产品分类id（数据字典id）
				disasterGrade	:undefined,//严重程度（0一般、1较大、2重大、3特大）
				disasterTime:undefined,//火灾日期
				casualtiesCount:undefined,//伤亡人数
				productTagId:[],//产品标签
				authorId:undefined,//原始作者用户Id（单）
				mastermindId:undefined,//策划Id（单）
				anaphaseId:undefined,//后期Id（多）
				productFileId:undefined,//主体文件Id
				isFree:undefined,//是否免费
				isTop:undefined,//是否置顶
				isHot:undefined,//是否热门
				productIntroduce:undefined,//产品简介
				firstImageUrl:'',//产品首图
				status:undefined,//发布状态：0未发布、1已发布、3已下架
				issuerId:undefined,//发布人id
				compilationsCoverImage:'',//产品合集封面图片
				compilationsHeadline:undefined,//产品名称
				compilationsCode:undefined,//产品合集编号
				productsIdList:[],//产品合集产品IdList
				isPerfect:undefined,
				fileUrl:'',
			}
			this.fileData = null
			this.relatedTableData = []
			this.fileUpload = {}
			this.addForm = {
				...this.needData
			}
			// 关键：needData 顶层可能没有 fileUrl 字段，需要用 $set 把它变成响应式属性，
			// 否则后续 this.addForm.fileUrl = xxx 的赋值不会触发 watch
			this.$set(this.addForm, 'fileUrl', this.addForm.fileUrl || '');
			this.selsetCategory = this.addForm.category;
			this.editFalse = true;
			if (this.activeName === 'first'){
				if (this.$refs.Form) {
          			this.$refs.Form.resetFields();
        		}
				this.addForm.anaphaseId = this.needData.anaphaseId.split(',').map(Number);
				this.addForm.productTagId = this.needData.productTagId.split(',').map(Number);
				
				if (this.addForm.productTypeSecondId){
					let params = {
						dataType:0,//数据类型:0:产品分类 1：产品标签
						parentId:this.needData.productTypeId,//父级Id
					}
					const res = await  getByDataCode(params)
					if (res.data.success) {
						this.productTypeIdChildList= res.data.response
					}
				}
				this.tableData1 = [];
				this.fileList=[]
				
				const fileMain = this.needData.productFile.filter(item=>item.parentId==0)
				if(fileMain[0].fileCategory==1){
					this.parentId = fileMain.parentId
					this.tableData1 = fileMain.map(item=>({
						fileName:item.fileName,
						size:item.fileSize,
						progress:100
					}))
				}else{
					// 2. 进行字段映射转换
					this.fileList = fileMain.map(item => ({
						name: item.fileName,   
						url: item.fileUrl,     
						uid: item.id      
					}));
				}																				
				this.dialogs.addType.dialog = true;
			}else {
				if (this.$refs.addRealation) {
          			this.$refs.addRealation.resetFields();
        		}
				
				if (this.needData.productTypeSecondId){
					let params = {
						dataType:0,//数据类型:0:产品分类 1：产品标签
						parentId:this.needData.productTypeId,//父级Id
					}
					const res = await  getByDataCode(params)
					if (res.data.success) {		
						this.productTypeIdChildList= res.data.response
					}
				}
				// if(this.needData.productsIdList?.length>=1){
					let params = {
						productCompilationsId :this.needData.id
					}
					getProductCompilationsIdListData(params).then(res=>{
						if (res.data.success){
							this.relatedTableData = res.data.response
						}
					})
				// }
				this.$nextTick(() => {
					this.initSortable();
				});
				
				
				this.dialogs.addCollection.dialog = true;
			}
		},
		//删除
		handleDel() {
			if(this.needData) {
				this.$confirm(`确定将永久删除？`,"提示",{
				}).then(() => {
							if (this.activeName === 'first'){
								let params = {
									productId: this.needData.id
								}
								deleteProductId(params).then((res) => {
									if (res.data.success){
										this.getDataList()
										this.$message({
											message:res.data.message,
											type:'success'
										})
									}else{
										this.$message({
											message:res.data.message,
											type:'warning'
										})
									}
								})
							}else {
								let params = {
									productCompilationsId : this.needData.id
								}
								deleteProductCompilationsId(params).then((res) => {
									if (res.data.success){
										this.getDataList()
										this.$message({
											message:res.data.message,
											type:'success'
										})
									}else{
										this.$message({
											message:res.data.message,
										})
									}
								})
 							}
							
						})
						.catch((err) => {
						
						})
			} else {
				this.$message({
					message:'请选择要删除的数据',
					type:'warning'
				})
			}
		},
		
		//获取字符空间
		async getNamespace(value){
			let params = {
				dataType:value,//数据类型:0:产品分类 1：产品标签
				parentId:undefined,//父级Id
			}
			const res = await getByDataCode(params)
			if (res.data.success) {
				if(value === 0){
					this.productTypeIdList= res.data.response
				}else{
					this.tagTypeIdList = res.data.response
				}
				
			}
		},
		// 获取行政区域
		getCityPage(params,name) {//name:0:获取省 1:获取市 2:获取区
			getAreaDictionaryList(params).then((res) => {
				var result = res.data
				if(result.success){
					if (name === 0 ){
						this.shengArr = result.response
					}
					if (name === 1 ){
						this.cityArr = result.response
					}
				}
			})
		},
		currentChange(val) {
			this.needData = val	
		},
		currentChange2(val) {
			this.needData = val
		},
		currentChange3(val) {
			this.needData2 = val
		},
		// 分页
		handleCurrentChange(val) {
			this.pages.pageIndex = val;
			this.getListData();
		},
		handleSizeChange(val){
			this.pages.pageSize = val;
			this.getListData();
		},
		handleCurrentChange1(val) {
			this.pages1.pageIndex = val;
			this.getListData();
		},
		handleSizeChange1(val){
			this.pages1.pageSize = val;
			this.getListData();
		},
		// 分页
		handleCurrentChange2(val) {
			this.pages2.pageIndex = val;
			this.relatedItems();
		},
		handleSizeChange2(val){
			this.pages2.pageSize = val;
			this.relatedItems();
		},
		// 分页
		handleCurrentChange3(val) {
			this.pages3.pageIndex = val;
			this.queryquestionsList();
		},
		handleSizeChange3(val){
			this.pages3.pageSize = val;
			this.queryquestionsList();
		},

		// 分页
		handleCurrentChange4(val) {
			this.pages4.pageIndex = val;
			this.queryquestionsList2();
		},
		handleSizeChange4(val){
			this.pages4.pageSize = val;
			this.queryquestionsList2();
		},

		// 分页
		handleCurrentChange5(val) {
			this.pages5.pageIndex = val;
			this.queryquestionsList3();
		},
		handleSizeChange5(val){
			this.pages5.pageSize = val;
			this.queryquestionsList3();
		},
		// 时间格式化
		formatCreateTime: function(row, column) {
			return !row || row == ""
					? ""
					: util.formatDate.format(new Date(row), "yyyy-MM-dd hh:mm");
		},
		// 表格数据分页条数累计
		indexMethod(index) {
			let currentPage = this.pages.pageIndex
			let pageSize = this.pages.pageSize
			return (index + 1) + (currentPage - 1) * pageSize
		},
		//点击试题数量
		handleQuestionCount(row){
			this.questionMaintenanceDialog = true;
			this.CurrentRowData = row;
			this.pages4.pageIndex = 1;
			this.pages4.pageSize = 20;
			this.queryquestionsList2();
		},

		
		// 新增试题
		addExamQuestion(){
			this.ConfigurationExamQuestionsdialog = true;
			this.needData = this.CurrentRowData;
			this.ConfigurationExamQuestions()
		},
		//点击配置试题
		ConfigurationExamQuestions(){
				if(this.activeName=="first"){
					if(!this.needData){
						this.$message.warning("请选择要配置的单品");
						return;
					}
				}
				this.CurrentRowData = this.needData;
				if(this.activeName=="second"){
					this.$message.warning("合集不允许关联试题");
					return;
				}
				if(this.needData){
					this.filters2.productId = this.needData.id
				}
				this.filters2.keyWord = undefined;
				this.filters2.questionsType = undefined;
				this.filters2.questionsType = undefined;
				this.ConfigurationExamQuestionsdialog = true
				this.pages3.pageIndex = 1;
				this.pages3.pageSize = 20;
				this.queryquestionsList()
		},
		handleDelete(row){
			this.removeRelationWithoutRefresh(row)
		},
		queryquestionsListFun(){
			this.pages3.pageIndex = 1;
			this.pages3.pageSize = 20;
			this.queryquestionsList();
		},
		queryquestionsList(){
			let params = {
				...this.filters2,
				pageIndex:this.pages3.pageIndex,
				pageSize:this.pages3.pageSize
			}
			getExaminationQuestionsListPage(params).then(res=>{
				if(res.data.success==true || res.data.status == 200){
					this.ExaminationQuestions = res.data.response.data
					this.pages3.dataCount = res.data.response.dataCount
				}
			})
		},
		queryquestionsList2(){
				let params = {
					isProduct:true,
					productId:this.CurrentRowData.id,
					pageIndex:this.pages4.pageIndex,
					pageSize:this.pages4.pageSize
				}
				getExaminationQuestionsListPage(params).then(res=>{
					if(res.data.success==true || res.data.status == 200){
						this.ExaminationQuestionsData = res.data.response.data
						this.pages4.dataCount = res.data.response.dataCount
					}
				})
		},
		queryquestionsList3(){
				let params = {
					isProduct:true,
					productId:this.needData.id,
					pageIndex:this.pages5.pageIndex,
					pageSize:this.pages5.pageSize
				}
				getExaminationQuestionsListPage(params).then(res=>{
					if(res.data.success==true || res.data.status == 200){
						this.ExaminationQuestionsData = res.data.response.data
						this.pages5.dataCount = res.data.response.dataCount
					}
				})
		},
		handleCustomSelectionChange(val){
			if(val.isRelation){
				this.addRelationWithoutRefresh(val)
			}else{
				this.removeRelationWithoutRefresh(val)
			}
		},
		addRelationWithoutRefresh(row) {
			let params = {
				productId: this.CurrentRowData.id,
				examinationQuestionsId: row.id // 确保这里是唯一ID
			}
			addProductQuestionsRelationApi(params).then(res=>{
				if(res.data.success || res.data.status==200){
					this.$message({
						message: res.data.message,
						type: "success",
					});
					this.queryquestionsList()
					this.queryquestionsList2()
					this.getListData()
				}
				
			})
    	},
		 removeRelationWithoutRefresh(row) {
			let params = {
				productId: this.CurrentRowData.id,
				examinationQuestionsId: row.id
			}
			 deleteProductQuestionsRelationApi(params).then(res=>{
				if(res.data.success || res.data.status==200){
					this.$message({
						message: res.data.message,
						type: "success",
					});
					this.queryquestionsList();
					this.queryquestionsList2()
					this.getListData()
				}
			 })
			
		},
		importExaminationQuestionsFun(){
			this.importQuestionsdialog=true
		},
		// 获取token
		getToken() {
			return localStorage.getItem("Token");
		},
		importQuestionsSubmit(){
			// 校验是否选择了文件
			if (!this.importQuestionsForm.file) {
				this.$message.warning("请先选择要导入的 Excel 文件");
				return;
			}

			
		this.$confirm("确认提交导入吗？", "提示", {}).then(() => {
        this.listLoading = true;
        // 构造 FormData
        const formData = new FormData();
        formData.append("file", this.importQuestionsForm.file);
        // 发送请求 (使用 axios 直接发送 formData)
        axios
          .post(importExaminationQuestionsApi, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: "Bearer " + this.getToken(),
            },
          })
          .then((res) => {
            this.listLoading = false;
            // 根据你的后端返回结构调整判断条件
            if (res.data.success || res.data.status==200) {
              this.$message({
                message: res.data.message || "导入成功",
                type: "success",
              });
              this.importQuestionsdialog = false;
              this.importQuestionsForm.file = null;
              if (this.$refs.importQuestionsupload) {
                this.$refs.importQuestionsupload.clearFiles();
              }
              this.queryquestionsList(); // 刷新列表
            } else {
              this.$message({
                message: res.data.message || "导入失败",
                type: "error",
              });
            }
          })
          .catch((err) => {
            this.listLoading = false;
            console.error(err);
            this.$message.error(
              "网络请求失败：" + (err.response?.data?.message || err.message)
            );
          		});
      		});
		},
		handleFileChange(file){
			 this.importQuestionsForm.file = file.raw;
		},
		relateQuestionsFun(){
			if(this.selectQuestion.length==0){
				this.$message.warning("请先选择要关联的试题");
				return;
			}else{
				let selectQuestionid = this.selectQuestion.map(item=>item.id).join(",")
				let params = {
					productId:this.needData.id,
					examinationQuestionsId:selectQuestionid
				}
				addProductQuestionsRelationApi(params).then(res=>{
					if(res.data.success==true || res.data.status==200){
							this.$message({
								message: res.data.message,
								type: "success",
							});
							this.queryquestionsList()
							
					}
				})
			}
		},
		initSortable() {
			
				const el = this.$refs.tableRef.$el.querySelector('.el-table__body-wrapper tbody');
				
				Sortable.create(el, {
						animation: 150, // 动画时长，让移动更平滑
						ghostClass: 'sortable-ghost', // 拖动时的占位符样式类名
						// handle: '.drag-handle', // 如果只想通过特定图标拖动，取消注释并添加对应class
						onEnd: ({ newIndex, oldIndex }) => {
						// 核心逻辑：当拖拽结束时触发
						if (newIndex === oldIndex) return;

						// 获取当前被拖拽的数据项
						const currRow = this.relatedTableData.splice(oldIndex, 1)[0];

						// 将该数据项插入到新位置
						this.relatedTableData.splice(newIndex, 0, currRow);

						this.relatedTableData.forEach((item, index) => {
								// 注意：这里假设你的排序是从 1 开始的。如果是从 0 开始，直接用 index
								item.sortOrder = index + 1;
               			});

						console.log("移动成功，准备提交新顺序:", this.relatedTableData);
					}
				});
			
   		},
		
		
		
	
		
	},
	watch: {
		'fileData': {
			handler(newVal, oldVal) {
			console.log('新值fileData:', newVal, '旧值fileData:', oldVal);
			if(newVal && this.addForm.fileUrl){
				this.addFileByCodeFun()
				console.log('fileData已存在')
			}
			},
			deep: true // 【关键】深度监听，确保能捕捉到对象内部的变化
		},
		'addForm.fileUrl': {
			handler(newVal, oldVal) {
			console.log('新值fileUrl:', newVal, '旧值fileUrl:', oldVal);
	
			if(newVal && this.fileData){
				this.addFileByCodeFun()
				console.log('fileUrl已存在')
			}
			},
			deep: true // 【关键】深度监听，确保能捕捉到对象内部的变化
		},
		
	},
	created(){
		this.getNamespace(0)//数据类型:0:产品分类 1：产品标签
		this.getNamespace(1)//数据类型:0:产品分类 1：产品标签
		this.getVideoLabelList()
		this.actionUrl = uploadTempPic;
		this.actionUrlFile = uploadDocumentFile;
		this.utils = util
		let routers = window.localStorage.getItem('router')
				? JSON.parse(window.localStorage.getItem('router'))
				: [];
		this.buttonList = getButtonList(this.$route.path, routers);
		this.videoUpload = new PlvVideoUpload({
			region: 'line1', // (可选)上传线路, 默认line1
			events: {
				Error: (err) => { // 错误事件回调
					console.log(err);
					let errMag = `（错误代码：${err.code}）${err.message}`;
					this.$alert(errMag, '标题名称', {
						confirmButtonText: '确定',
						type: 'error',
					});
				},
				UploadComplete: () => { // 全部上传任务完成回调
					console.info('上传结束：', this.videoUpload);
					this.$message({
						message: '全部上传任务完成',
						type: 'success'
					});
				}
			}
		});
		this.getListData();
		this.userInfoList();
	},
	computed:{
		headers(){
			return {
				"Authorization": 'Bearer ' + localStorage.getItem("Token")
			}
		},
		 uploadData() {
			return {
			parentId: 0,
			fileAttribute: 0,
			fileCategory: this.selsetCategory,
			authorId: this.addForm.authorId,  // 响应式依赖
		}
  }
		
	},
	
	beforeDestroy() {
		clearInterval(this.timer);
		// 移除全局回车监听
		removeEnterSearch();
	},
	mounted() {
		// 添加全局回车搜索功能
		useEnterSearch(() => {
			this.getListData();
		});
		
		this.uploadDataFile ={
			parentId:this.needData?this.needData.productFileId:0,
			fileCategory:this.addForm.category,
			fileAttribute:0,
			authorId:this.addForm.authorId,
		}
		
	},
}
</script>

<style lang="stylus" scoped>
::v-deep .el-radio-button__inner{
	width :240px !important;
}
.avatar-uploader  {
	width: 320px;
	height: 180px;
	border: 1px dashed #d9d9d9;
	border-radius: 6px;
	cursor: pointer;
	position: relative;
	overflow: hidden;
}
.avatar-uploader:hover {
	border-color: #409EFF;
}
.avatar-uploader-icon {
	font-size: 28px;
	color: #8c939d;
	width: 320px;
	height: 180px;
	line-height: 180px;
	text-align: center;
}
.avatar {
	width: 320px;
	height: 180px;
	display: block;
}

.avatar-uploader3  {
	width: 135px;
	height: 180px;
	border: 1px dashed #d9d9d9;
	border-radius: 6px;
	cursor: pointer;
	position: relative;
	overflow: hidden;
}
.avatar-uploader3:hover {
	border-color: #409EFF;
}
.avatar-uploader-icon3 {
	font-size: 28px;
	color: #8c939d;
	width: 135px;
	height: 180px;
	line-height: 180px;
	text-align: center;
}
.avatar3 {
	width: 135px;
	height: 180px;
	display: block;
}

.projectName {
	text-align: center;
}
.projectSelect {
	margin-bottom: 15px;
}
.projectTitle {
	margin-bottom: 15px
}
.replyBtn {
	margin: 10px 0;
	color: #409eff;
	cursor: pointer;
	width: 30px;
}
.replyMessage {
	background: #eee;
	line-height: 30px;
	padding: 5px;
	border-radius: 2px;
	margin: 5px 15px;
}
.titleTimer {
	margin-left: 10px;
}
.green_t {
	color: green;
}
.red_t {
	color: red;
}
.all{
	display:flex;
}
.all .item  ::v-deep .el-form-item__content{
    margin-left: 0px !important
}


</style>
